// 价格频道：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 业务状态与选项
export const businessDisplay = Object.freeze({
  "priceChannel.businessDisplay.sourceObservationBasis":
    "Source observations: actual batch-price changes relative to the first historical observation (base=100), not independently published indices.",
  "priceChannel.businessDisplay.publishedIndexMissing":
    "This release has no published composite index for this product. Select sources to view existing quote history.",
  "priceChannel.businessDisplay.observationEventsOnly":
    "These are published quote observations. News events and external announcements have not been migrated.",
  "priceChannel.businessDisplay.publishedTrendSummary":
    "{count} published index points in the current 7D window. Fixed release: {version}",
  "priceChannel.businessDisplay.publishedCoverageSummary":
    "{specs} specifications · {sources} sources · {batches} inventory batches",
  "priceChannel.businessDisplay.announcementsNotPublished":
    "No external research reports or source announcements are published in this release.",
  "priceChannel.businessDisplay.latestSourceCoverageBasis":
    "Coverage uses each batch's latest published observation date, not full-history coverage.",
  "priceChannel.businessDisplay.inventoryEventStatus.VALID": "Valid",
  "priceChannel.businessDisplay.inventoryEventStatus.EXPIRED": "Expired",
  "priceChannel.businessDisplay.inventoryEventStatus.WITHDRAWN": "Withdrawn",
  "priceChannel.businessDisplay.condition.NEW": "New",
  "priceChannel.businessDisplay.condition.OPEN_BOX_NEW": "New, open box",
  "priceChannel.businessDisplay.condition.OPEN_BOX": "Open box",
  "priceChannel.businessDisplay.condition.UNVERIFIED": "Unverified",
  "priceChannel.businessDisplay.packaging.ESD_TRAY": "ESD tray",
  "priceChannel.businessDisplay.packaging.WAFER_BOX": "Wafer box",
  "priceChannel.businessDisplay.packaging.FACTORY_TRAY":
    "Original manufacturer tray",
  "priceChannel.businessDisplay.packaging.RETAIL_BOX": "Retail box",
  "priceChannel.businessDisplay.packaging.ESD_BAG": "ESD bag",
  "priceChannel.businessDisplay.packaging.RETAIL_BLISTER":
    "Retail blister pack",
  "priceChannel.businessDisplay.unit.PCS": "pcs",
  "priceChannel.businessDisplay.unit.WAFER": "wafer",
  "priceChannel.businessDisplay.dateCode": "Date Code",
  "priceChannel.businessDisplay.quoteAwaitingTarget":
    "Awaiting target price / inquiry",
  "priceChannel.businessDisplay.quoteNeedsDetails": "Quote details pending",
  "priceChannel.businessDisplay.currencyPending": "Currency pending",
  "priceChannel.businessDisplay.companyTranslationReference":
    "Reference translation for display only; the original legal name prevails",
  "priceChannel.businessDisplay.subject.BRAND": "Brand",
  "priceChannel.businessDisplay.subject.CHANNEL": "Channel",
  "priceChannel.businessDisplay.subject.ENTERPRISE": "Company",
  "priceChannel.businessDisplay.subject.ORGANIZATION": "Organization",
  "priceChannel.businessDisplay.subject.XSOU": "XSOU",
  "priceChannel.businessDisplay.status.DRAFT": "Draft",
  "priceChannel.businessDisplay.status.SUBMITTED": "Submitted",
  "priceChannel.businessDisplay.status.UNDER_REVIEW": "Under review",
  "priceChannel.businessDisplay.status.PENDING": "Pending",
  "priceChannel.businessDisplay.status.LEADER_PENDING":
    "Awaiting leadership review",
  "priceChannel.businessDisplay.status.RETURNED": "Returned",
  "priceChannel.businessDisplay.status.REJECTED": "Rejected",
  "priceChannel.businessDisplay.status.APPROVED": "Approved",
  "priceChannel.businessDisplay.status.PUBLISHING": "Publishing",
  "priceChannel.businessDisplay.status.CALCULATING": "Calculating",
  "priceChannel.businessDisplay.status.PUBLISHED": "Published",
  "priceChannel.businessDisplay.status.PUBLISH_FAILED": "Publication failed",
  "priceChannel.businessDisplay.status.CALCULATION_FAILED":
    "Market calculation failed",
  "priceChannel.businessDisplay.status.FAILED": "Failed",
  "priceChannel.businessDisplay.status.ACTIVE": "Active",
  "priceChannel.businessDisplay.stage.DEPARTMENT": "Department review",
  "priceChannel.businessDisplay.stage.LEADER": "Leadership review",
  "priceChannel.businessDisplay.stage.OPERATIONS": "Operations review",
  "priceChannel.businessDisplay.decision.APPROVE": "Approved",
  "priceChannel.businessDisplay.decision.RETURN": "Returned",
  "priceChannel.businessDisplay.decision.REJECT": "Rejected",
  "priceChannel.businessDisplay.outcome.SUCCEEDED": "Succeeded",
  "priceChannel.businessDisplay.outcome.FAILED": "Failed",
  "priceChannel.businessDisplay.certification.SELF_OWNED_BRAND":
    "Self-owned brand",
  "priceChannel.businessDisplay.certification.AUTHORIZED_PLATFORM":
    "Authorized platform",
  "priceChannel.businessDisplay.certification.PARTNER_CHANNEL":
    "Partner channel",
  "priceChannel.businessDisplay.qualificationType.enterpriseProfile":
    "Company profile documents",
  "priceChannel.businessDisplay.qualificationType.other":
    "Other price-channel documents",
  "priceChannel.businessDisplay.qualificationMeta.fileName": "File name",
  "priceChannel.businessDisplay.qualificationMeta.extension": "Extension",
  "priceChannel.businessDisplay.qualificationMeta.size": "File size",
  "priceChannel.businessDisplay.qualificationMeta.selectedAt": "Selected at",
  "priceChannel.businessDisplay.qualificationMeta.demoAttachmentId":
    "Attachment ID",
  "priceChannel.businessDisplay.category.flash-wafer": "Flash wafer",
  "priceChannel.businessDisplay.category.memory-wafer": "Memory wafer",
  "priceChannel.businessDisplay.category.flash-chip": "Flash chip",
  "priceChannel.businessDisplay.category.memory-chip": "Memory chip",
  "priceChannel.businessDisplay.category.memory-module": "Memory module",
  "priceChannel.businessDisplay.category.solid-state-drive":
    "Solid-state drive",
  "priceChannel.businessDisplay.category.flash-card": "Flash card",
  "priceChannel.businessDisplay.category.embedded-storage": "Embedded storage",
  "priceChannel.businessDisplay.category.usb-flash-drive": "USB flash drive",
  "priceChannel.businessDisplay.dimension.wafer-device-kind": "Type",
  "priceChannel.businessDisplay.dimension.flash-memory-kind": "Type",
  "priceChannel.businessDisplay.dimension.flash-cell-type": "Process",
  "priceChannel.businessDisplay.dimension.dram-generation": "Generation",
  "priceChannel.businessDisplay.dimension.bit-density-gbit": "Capacity",
  "priceChannel.businessDisplay.dimension.byte-capacity-gbyte": "Capacity",
  "priceChannel.businessDisplay.dimension.clock-mhz": "Frequency",
  "priceChannel.businessDisplay.dimension.data-rate-mtps": "Data rate",
  "priceChannel.businessDisplay.dimension.bus-width": "Bus width",
  "priceChannel.businessDisplay.dimension.organization": "Organization",
  "priceChannel.businessDisplay.dimension.stack-layer-count": "Layers",
  "priceChannel.businessDisplay.dimension.wafer-diameter-mm": "Diameter",
  "priceChannel.businessDisplay.dimension.interface-rate-mtps":
    "Interface rate",
  "priceChannel.businessDisplay.dimension.package": "Package",
  "priceChannel.businessDisplay.dimension.package-structure": "Structure",
  "priceChannel.businessDisplay.dimension.protocol-version": "Protocol",
  "priceChannel.businessDisplay.dimension.interface-generation": "Interface",
  "priceChannel.businessDisplay.dimension.form-factor": "Form factor",
  "priceChannel.businessDisplay.dimension.ecc-capability": "ECC",
  "priceChannel.businessDisplay.dimension.rank": "Rank",
  "priceChannel.businessDisplay.dimension.speed-class": "Class",
  "priceChannel.businessDisplay.value.bare-die": "Bare die",
  "priceChannel.businessDisplay.value.packaged-ic": "Packaged IC",
  "priceChannel.businessDisplay.value.not-applicable": "Not applicable",
  "priceChannel.businessDisplay.value.single-die": "Single die",
  "priceChannel.businessDisplay.value.multi-die": "Multi-die",
  "priceChannel.businessDisplay.value.2.5-inch": "2.5-inch",
  "priceChannel.businessDisplay.value.consumer": "Consumer",
  "priceChannel.businessDisplay.value.enterprise": "Enterprise",
  "priceChannel.businessDisplay.value.secondary-market": "Secondary market",
  "priceChannel.businessDisplay.value.managed-package": "Managed package",
  "priceChannel.businessDisplay.value.usb-mass-storage": "USB mass storage",
  "priceChannel.businessDisplay.value.high-speed": "High speed",
  "priceChannel.businessDisplay.value.usb-flash-drive": "USB flash drive",
  "priceChannel.businessDisplay.formInvalid":
    "Check the form fields and try again",
  "priceChannel.businessDisplay.reviewInvalid":
    "Check the review opinion and version, then try again",
  "priceChannel.businessDisplay.originalContentHint":
    "Submitted content and review opinions below are shown in the original language. Changing the interface language will not alter the record.",
  "priceChannel.businessDisplay.validation.array": "Enter {field} as a list",
  "priceChannel.businessDisplay.validation.arrayLimit":
    "{field} can contain at most 100 items",
  "priceChannel.businessDisplay.validation.fileId":
    "Item {index} needs a file ID",
  "priceChannel.businessDisplay.validation.arrayEntry":
    "Item {index} has an invalid format",
  "priceChannel.businessDisplay.validation.text": "Enter text for {field}",
  "priceChannel.businessDisplay.validation.arrayRequired":
    "Item {index} needs {field}",
  "priceChannel.businessDisplay.validation.dimensionValue":
    "Item {index} needs a specification value or option ID",
  "priceChannel.businessDisplay.validation.decimal":
    "{field}{location} must be a non-negative decimal number",
  "priceChannel.businessDisplay.validation.currency":
    "Item {index} needs a three-letter uppercase currency code",
  "priceChannel.businessDisplay.validation.required": "Enter {field}",
});

// 行情界面
export const market = Object.freeze({
  "priceChannel.title": "Market Index",
  "priceChannel.channelName": "Price Channel",
  "priceChannel.market": "Markets",
  "priceChannel.categories": "Categories",
  "priceChannel.watchlist": "Watchlist",
  "priceChannel.my": "My Account",
  "priceChannel.personalNavigation": "Price channel account navigation",
  "priceChannel.messageCenter": "Message Center",
  "priceChannel.primaryNavigation": "Price channel navigation",
  "priceChannel.marketNavigation": "Market index navigation",
  "priceChannel.navigationHint":
    "Click to restore your position; double-click to refresh this page",
  "priceChannel.brandFilter": "Brand",
  "priceChannel.marketFilter": "Product categories and brand filters",
  "priceChannel.categoryHeading": "Category Markets",
  "priceChannel.productCategory": "Product category",
  "priceChannel.applicationReview": "Submission review",
  "priceChannel.applicationReviewCount": "Submission review ({count})",
  "priceChannel.invalidRegionRoute":
    "The region in this URL is unknown. Clear it or choose another; the scope was not expanded to all sources.",
  "priceChannel.invalidCategoryRoute":
    "The product category in this URL is unknown. Choose another category.",
  "priceChannel.regionLoadFailed":
    "Could not load regional quotes. Choose the region again.",
  "priceChannel.categoryDescription":
    "Choose a product category, then narrow the market by any dimension.",
  "priceChannel.viewMultidimensional": "Explore multi-dimensional markets",
  "priceChannel.myWatchlist": "My Watchlist",
  "priceChannel.myFavorites": "My Favorites",
  "priceChannel.itemsCount": "{count} items",
  "priceChannel.viewAll": "View all",
  "priceChannel.noFavorites": "No favorites yet",
  "priceChannel.favoritesHint":
    "Select the + on a market card to save it here.",
  "priceChannel.allBrands": "All brands",
  "priceChannel.marketOverview": "Market Overview",
  "priceChannel.levelOneMarket": "Primary market",
  "priceChannel.sampleSources": "{samples} samples · {sources} sources",
  "priceChannel.marketMovers": "Market Movers",
  "priceChannel.mover.positive": "Largest gains first",
  "priceChannel.mover.negative": "Largest losses first",
  "priceChannel.mover.latest": "Recently updated",
  "priceChannel.noMatchingMarket": "No matching markets are available yet",
  "priceChannel.hotDiscovery": "Trending Discoveries",
  "priceChannel.hotDiscoveryTypes": "Trending discovery types",
  "priceChannel.popularMarkets": "Trending markets",
  "priceChannel.popularProducts": "Trending products",
  "priceChannel.multidimensionalMarket": "Multi-dimensional market",
  "priceChannel.regionalHotProducts": "Trending products across regions",
  "priceChannel.brandActivity": "Brand Activity",
  "priceChannel.productCategories":
    "{products} products · {categories} categories",
  "priceChannel.updatedAt": "Updated {time}",
  "priceChannel.sourceActivity": "Source Activity",
  "priceChannel.registeredSources": "{count} registered sources",
  "priceChannel.recentAt": "Latest {time}",
  "priceChannel.majorPlatform": "Major platform",
  "priceChannel.partnerChannel": "Partner channel",
  "priceChannel.marketPerformance": "Market Performance",
  "priceChannel.regionFilter": "Filter by quote-source region",
  "priceChannel.noMatchingRegion": "No matching regions",
  "priceChannel.region.country": "Country",
  "priceChannel.region.admin": "State/Province",
  "priceChannel.region.city": "City",
  "priceChannel.currentNext": "Currently {current}; click to switch to {next}",
  "priceChannel.next": "Click to switch to {next}",
  "priceChannel.sort.DEFAULT": "Default quotes",
  "priceChannel.sort.VALUE": "Best quotes",
  "priceChannel.sort.VALUE.basis":
    "Ranked by composite index, not the lowest live executable offer",
  "priceChannel.sort.LATEST": "Latest quotes",
  "priceChannel.view.charts": "Charts",
  "priceChannel.view.list": "List",
  "priceChannel.multidimensionalFilter": "Multi-dimensional market filters",
  "priceChannel.addFavorite": "Add to favorites",
  "priceChannel.chooseWatchlist": "Choose a watchlist group",
  "priceChannel.watchlistAdded": "Added to watchlist",
  "priceChannel.watchlistManage": "Manage all watchlists",
  "priceChannel.watchlistSignIn": "Sign in to view your watchlist markets.",
  "priceChannel.removeFavorite": "Remove from favorites",
  "priceChannel.searchResultsFor": "Search results for {name}",
  "priceChannel.selectionPath": "Current market category path",
  "priceChannel.emptyScopeTitle": "No products match the restored filters",
  "priceChannel.emptyScopeHint":
    "The filters are preserved. Remove invalid conditions to continue viewing markets.",
  "priceChannel.removeCondition": "Remove {condition}",
  "priceChannel.dimension": "Dimension",
  "priceChannel.cachedCondition": "Cached condition",
  "priceChannel.condition": "Condition",
  "priceChannel.unknown": "Unknown",
  "priceChannel.regionRelated": "Related Regions",
  "priceChannel.regionRelatedGroup": "Related regions: {name}",
  "priceChannel.regionRelatedLoadRetry":
    "Regional markets could not be loaded. Click to retry",
  "priceChannel.regionRelatedPreparing": "Preparing related regions…",
  "priceChannel.hidePageArrows": "Hide pagination arrows within this group",
  "priceChannel.showPageArrows": "Show pagination arrows within this group",
  "priceChannel.batchPending": "Batch pending verification",
  "priceChannel.availableQuantity": "Available quantity",
  "priceChannel.fabricationInfo": "Fabrication information",
  "priceChannel.packaging": "Packaging",
  "priceChannel.conditionLabel": "Condition",
  "priceChannel.stockLocation": "Stock location",
  "priceChannel.minimumOrderQuantity": "Minimum order quantity",
  "priceChannel.deliveryLeadTime": "Lead time",
  "priceChannel.quantityTiers": "Quantity tiers",
  "priceChannel.noQuantityTiers":
    "No quantity tiers are available for this quote",
  "priceChannel.quoteHistory": "Quote history",
  "priceChannel.status.ACTIVE": "Active",
  "priceChannel.status.EXPIRED": "Expired",
  "priceChannel.status.SOLD_OUT": "Sold out",
  "priceChannel.status.WITHDRAWN": "Withdrawn",
  "priceChannel.resolution.EXACT": "Exact batch",
  "priceChannel.resolution.PROBABLE": "Probable match",
  "priceChannel.resolution.UNKNOWN": "Details pending",
  "priceChannel.quoteSource": "Quote source",
  "priceChannel.sourceBatches": "Sources and batches",
  "priceChannel.partBatches": "Parts and batches",
  "priceChannel.switchToSources": "Browse by quote source",
  "priceChannel.switchToParts": "Browse by part number",
  "priceChannel.batchSourceCount": "{batches} batches · {sources} sources",
  "priceChannel.partActiveCount":
    "{parts} part numbers · {active}/{total} active",
  "priceChannel.noValidQuote": "No valid quotes",
  "priceChannel.none": "None",
  "priceChannel.quantityUnknown": "Quantity unknown",
  "priceChannel.timePending": "Time pending",
  "priceChannel.realtimeQuotes": "Live Quotes",
  "priceChannel.sourceCount": "{count} sources",
  "priceChannel.currentQuote": "Current quote / TP",
  "priceChannel.productionMark": "Production mark",
  "priceChannel.moq": "MOQ",
  "priceChannel.latestTime": "Latest time",
  "priceChannel.noApprovedQuotes": "No approved quotes are available",
  "priceChannel.coverageMatrix": "Source Coverage Matrix",
  "priceChannel.coverageHint": "Source and date coverage",
  "priceChannel.source": "Source",
  "priceChannel.covered": "Covered",
  "priceChannel.noCoverage": "No source coverage information",
  "priceChannel.multiSeriesTrend": "Multi-series market trend chart",
  "priceChannel.noChartData": "No chart data is available",
  "priceChannel.pendingDetail": "Pending details",
  "priceChannel.indexTrend": "Market index trend",
  "priceChannel.pointAria": "{name}, {time}, index {value}",
  "priceChannel.dailyClose":
    "Close {close} · Previous close {previous} · Daily change {change}",
  "priceChannel.sourceVisibility": "Trend source visibility controls",
  "priceChannel.hideAll": "Hide all",
  "priceChannel.showAll": "Show all",
  "priceChannel.sectorIndex": "{name} market index",
  "priceChannel.sectorTrend": "{name} market index trend",
  "priceChannel.indexPeriod": "Market index time period",
  "priceChannel.customRangeFailed": "Could not apply this time range",
  "priceChannel.industryScope": "Related industry market ranges",
  "priceChannel.dimensionCandidates": "{name} options",
  "priceChannel.technicalCandidates": "Technology options",
  "priceChannel.backHome": "Back to market home",
  "priceChannel.dataCutoff": "Data as of {time}",
  "priceChannel.backCategory": "Back to categories",
  "priceChannel.retry": "Retry",
  "priceChannel.loadingRelease": "Loading the current market release…",
  "priceChannel.currentScope": "Current market",
  "priceChannel.relatedProducts": "{count} related products",
  "priceChannel.scopeTrend": "Current market index trend",
  "priceChannel.scopePending":
    "This selection is still being calculated and is not yet in the public release.",
  "priceChannel.scopeRecovering":
    "Calculation is taking longer. This page checks every 10 seconds; existing content remains available.",
  "priceChannel.scopeRecoveryStopped":
    "Automatic checks have stopped. Calculation may still be running; retry to check its status.",
  "priceChannel.relationRecoveryStopped":
    "Some related curves are not ready. Automatic checks have stopped; retry fetches only missing curves.",
  "priceChannel.scopeFailed":
    "This selection could not finish calculating. Try again later.",
  "priceChannel.scopeEmpty":
    "No product indexes are available for this selection.",
  "priceChannel.categoryEmpty":
    "No market data is available for this category.",
  "priceChannel.loadingMore": "Loading…",
  "priceChannel.loadMore": "Load more",
  "priceChannel.instrumentIndex": "Product Index",
  "priceChannel.instrument": "Product",
  "priceChannel.instrumentTrend": "{name} index trend",
  "priceChannel.instrumentEmpty":
    "No index points are available for this product release.",
  "priceChannel.partNumbers": "Part Numbers",
  "priceChannel.partNumbersEmpty":
    "No public part numbers are available in this release.",
  "priceChannel.compositeIndex": "Composite Index",
  "priceChannel.missing": "Unavailable",
  "priceChannel.pending": "Pending confirmation",
  "priceChannel.product": "Product",
  "priceChannel.serviceUnavailable":
    "The price channel is temporarily unavailable. Please try again later.",
  "priceChannel.releaseExpired":
    "This market release has expired. Please reload.",
  "priceChannel.viewForbidden": "Your current identity cannot view this data.",
  "priceChannel.loadFailed":
    "Market data could not be loaded. Please try again later.",
  "priceChannel.identityRestoring": "Restoring your price channel identity…",
  "priceChannel.businessEyebrow": "My Account · Price Channel",
  "priceChannel.viewMarket": "View Market Index",
  "priceChannel.identityChecking":
    "Checking your account's price channel identity…",
  "priceChannel.currentAccount": "Current marketplace account",
  "priceChannel.account": "Account {id}",
  "priceChannel.identity": "Price channel identity",
  "priceChannel.noIdentity":
    "This marketplace account has no active price channel identity.",
  "priceChannel.authorizedScopes": "{count} authorized subject scopes",
  "priceChannel.businessNavigation": "Price channel business navigation",
  "priceChannel.businessForbidden":
    "This identity cannot access this business section.",
  "priceChannel.backIdentity": "Back to channel identity",
  "priceChannel.availableBusiness": "Available actions",
  "priceChannel.bindIdentity":
    "Ask your administrator to assign an active member identity to this account.",
  "priceChannel.noBusiness":
    "This identity has no available price channel actions.",
  "priceChannel.refresh": "Refresh",
  "priceChannel.reading": "Loading…",
  "priceChannel.noRecords": "No relevant records are available.",
  "priceChannel.watchlistItems": "{count} watchlist items",
  "priceChannel.memberIdentity": "Member identity",
  "priceChannel.section.identity": "Channel identity",
  "priceChannel.section.activity": "Activity center",
  "priceChannel.section.watchlists": "Market watchlists",
  "priceChannel.section.certifications": "Enterprise certification",
  "priceChannel.section.submissions": "Business submissions",
  "priceChannel.section.reviews": "Reviews",
  "priceChannel.section.results": "Review results",
  "priceChannel.activity.all": "All",
  "priceChannel.activity.market": "Market follows",
  "priceChannel.activity.inventory": "Parts / inventory",
  "priceChannel.activity.workflow": "Workflow",
  "priceChannel.activity.system": "System",
  "priceChannel.activityProjectionHint":
    "Only submissions and review tasks visible to this identity are projected here; these are not push notifications.",
  "priceChannel.activitySourceUnavailable":
    "No formal event API is available for this notification type; simulated messages are not shown.",
  "priceChannel.watchlistName": "Watchlist group name",
  "priceChannel.createWatchlist": "Create group",
  "priceChannel.removeWatchlistItem": "Remove watchlist item",
  "priceChannel.invalidSelection":
    "Some filters from the old link cannot be mapped to this release. Please select again.",
  "priceChannel.loginExpired":
    "Your session has expired. Please sign in again.",
  "priceChannel.accountForbidden":
    "This account or identity is not authorized.",
  "priceChannel.businessUnavailable":
    "The price channel business service is temporarily unavailable. Please try again later.",
  "priceChannel.readFailed": "Could not load data. Please try again later.",
  "priceChannel.role.platform_leader": "Platform leadership",
  "priceChannel.role.company_business": "Company business",
  "priceChannel.role.company_operations": "Company operations",
  "priceChannel.role.self_owned_brand": "Owned brand",
  "priceChannel.role.authorized_platform": "Authorized platform",
  "priceChannel.role.partner_channel": "Partner channel",
  "priceChannel.role.readonly_customer": "Read-only customer",
  "priceChannel.submissions": "Business Submissions",
  "priceChannel.submission.PRODUCT": "Product",
  "priceChannel.submission.PART_NUMBER": "Standard part number",
  "priceChannel.submission.INVENTORY": "Inventory batch",
  "priceChannel.submission.OFFER": "Quote observation",
  "priceChannel.field.instrumentId": "Product ID",
  "priceChannel.field.partNumberId": "Standard part number ID",
  "priceChannel.field.categoryId": "Category ID *",
  "priceChannel.field.brandRef": "Brand reference *",
  "priceChannel.field.code": "Product code *",
  "priceChannel.field.title": "Product name *",
  "priceChannel.field.instrumentKind": "Product type *",
  "priceChannel.field.dimensions": "Technical dimensions",
  "priceChannel.field.evidenceRefs": "Evidence references",
  "priceChannel.field.manufacturerPartNumber": "Manufacturer part number *",
  "priceChannel.field.attributes": "Part attributes",
  "priceChannel.field.batchId": "Inventory batch ID",
  "priceChannel.field.sourceProviderId": "Quote source ID *",
  "priceChannel.field.batchCode": "Batch code",
  "priceChannel.field.dateCode": "Date code",
  "priceChannel.field.originRegionId": "Origin region ID",
  "priceChannel.field.stockRegionId": "Stock region ID",
  "priceChannel.field.packaging": "Packaging",
  "priceChannel.field.condition": "Condition",
  "priceChannel.field.stockQuantity": "Stock quantity *",
  "priceChannel.field.quantityUnit": "Quantity unit *",
  "priceChannel.field.minimumOrderQuantity": "Minimum order quantity",
  "priceChannel.field.inventoryBatchId": "Inventory batch ID *",
  "priceChannel.field.amount": "Unit price *",
  "priceChannel.field.currency": "Currency *",
  "priceChannel.field.priceUnit": "Price unit *",
  "priceChannel.field.observedAt": "Quote time (ISO 8601) *",
  "priceChannel.field.expiresAt": "Expiry time (ISO 8601)",
  "priceChannel.field.sourceRecordId": "Source record ID",
  "priceChannel.field.sourceRevision": "Source revision",
  "priceChannel.field.tiers": "Quantity tiers",
  "priceChannel.array.dimensionId": "Dimension ID *",
  "priceChannel.array.optionId": "Option ID",
  "priceChannel.array.normalizedValue": "Specification value",
  "priceChannel.array.unit": "Unit",
  "priceChannel.array.attributeCode": "Attribute code *",
  "priceChannel.array.label": "Attribute name",
  "priceChannel.array.value": "Attribute value",
  "priceChannel.array.minimumQuantity": "Minimum quantity *",
  "priceChannel.array.maximumQuantity": "Maximum quantity",
  "priceChannel.array.amount": "Unit price *",
  "priceChannel.array.currency": "Currency *",
  "priceChannel.array.priceUnit": "Price unit *",
  "priceChannel.array.fileId": "File ID {index}",
  "priceChannel.array.addNamed": "Add {label}",
  "priceChannel.array.remove": "Remove item",
  "priceChannel.array.removeNamed": "Remove item {index} from {label}",
  "priceChannel.field.existingInstrumentId":
    "Existing product ID (blank for new)",
  "priceChannel.field.requiredInstrumentId": "Product ID *",
  "priceChannel.field.existingPartNumberId":
    "Existing part number ID (blank for new)",
  "priceChannel.field.existingBatchId": "Existing batch ID (blank for new)",
  "priceChannel.closeDraft": "Close draft form",
  "priceChannel.newDraft": "New draft",
  "priceChannel.draftHint":
    "The business database stores the draft envelope, while Platform stores its immutable revision. Saving does not submit it for review.",
  "priceChannel.noAuthorizedSubject":
    "This identity has no authorized subject and cannot create a submission.",
  "priceChannel.subject": "Submission subject",
  "priceChannel.chooseSubject": "Select an authorized subject",
  "priceChannel.submissionType": "Submission type",
  "priceChannel.saving": "Saving…",
  "priceChannel.saveDraft": "Save draft",
  "priceChannel.saveChanges": "Save revision",
  "priceChannel.resumeReturnedDraft": "Resume returned draft",
  "priceChannel.originalSubmissionFields": "Submitted content",
  "priceChannel.readingSubmissions": "Loading submissions…",
  "priceChannel.noSubmissions": "No submissions yet.",
  "priceChannel.publicationRequest": "Publication request {id}",
  "priceChannel.awaitRelease": "Awaiting public release",
  "priceChannel.viewStatus": "View status",
  "priceChannel.submitForReview": "Submit for review",
  "priceChannel.confirmReview":
    "Submit this immutable revision to operations review? It cannot be edited in place afterward.",
  "priceChannel.confirmSubmit": "Confirm submission",
  "priceChannel.cancel": "Cancel",
  "priceChannel.businessStatus": "Business status",
  "priceChannel.version": "Version",
  "priceChannel.revision": "Revision reference",
  "priceChannel.releaseVersion": "Release version",
  "priceChannel.notActivated": "Not activated",
  "priceChannel.publicationStage": "Publication stage",
  "priceChannel.publicationReceiptTimeline": "Publication receipts",
  "priceChannel.publicationTimelineUnavailable":
    "Publication receipt fields are unavailable. Check the backend version; history is not inferred from current status.",
  "priceChannel.publicationReceiptTimeHint":
    "Ordered by receipt time at the mall, not event occurrence time. Arrival order does not change current status.",
  "priceChannel.publicationTimelineTruncated":
    "Only the latest 200 receipts are shown. Earlier records are not loaded here.",
  "priceChannel.noPublicationReceipt": "No publication receipts yet.",
  "priceChannel.publicationReceiptStage.FACT_ACCEPTED": "Fact acceptance",
  "priceChannel.publicationReceiptStage.MARKET_RELEASE_ACTIVATED":
    "Release activation",
  "priceChannel.publicationFactPending": "Fact acceptance pending; not public",
  "priceChannel.publicationCalculating":
    "Fact accepted; awaiting index and public release",
  "priceChannel.publicationActivated": "Public release {version} activated",
  "priceChannel.submissionPayloadUnavailable":
    "This detail lacks a server-verified revision payload; the original fields cannot be verified.",
  "priceChannel.submissionTimelineUnavailable":
    "The detail API has not returned the full review timeline; current status cannot reconstruct history.",
  "priceChannel.returnRecoveryUnavailable":
    "Resuming a returned draft requires its original revision payload. This detail is incomplete.",
  "priceChannel.submissionReadFailed": "Could not load submissions",
  "priceChannel.subjectRequired": "Select an authorized submission subject",
  "priceChannel.draftSaved":
    "Draft {id} saved. You can explicitly submit it for review below.",
  "priceChannel.draftSaveFailed":
    "Could not save the draft. You can retry the same request",
  "priceChannel.draftChanged": "The draft has changed. Refresh and try again",
  "priceChannel.submitted": "Sent to operations for review.",
  "priceChannel.submitFailed": "Could not submit for review",
  "priceChannel.detailReadFailed": "Could not load submission details",
  "priceChannel.reviewHint":
    "Only tasks within your current Spring identity and authorized scope are shown. The latest version is fetched for each review, and the server makes the final authorization decision.",
  "priceChannel.readingReviews": "Loading review queue…",
  "priceChannel.noReviews": "No items awaiting review.",
  "priceChannel.operationsReview": "Operations review",
  "priceChannel.viewDetail": "View details",
  "priceChannel.approve": "Approve",
  "priceChannel.return": "Return",
  "priceChannel.reject": "Reject",
  "priceChannel.currentVersion": "Current version {version}",
  "priceChannel.typeRevision": "Type {type} · revision {revision}",
  "priceChannel.evidenceCount": "{count} evidence files",
  "priceChannel.reviewPayloadUnavailable":
    "This detail lacks a server-verified submission payload or review history. Review remains unavailable.",
  "priceChannel.reviewContentChanged":
    "The review content changed. Open the latest details before deciding",
  "priceChannel.confirmDecision": "Confirm {decision}?",
  "priceChannel.reviewOpinion": "Review note (1–25 characters)",
  "priceChannel.processing": "Processing…",
  "priceChannel.confirmAction": "Confirm",
  "priceChannel.certificationTitle": "Enterprise certification · {id}",
  "priceChannel.reviewReadFailed": "Could not load review tasks",
  "priceChannel.reviewDetailReadFailed": "Could not load review details",
  "priceChannel.reviewDone":
    "Review {decision} complete. Public markets must still await publication and Release activation.",
  "priceChannel.reviewFailed": "Review failed. Refresh and try again",
  "priceChannel.closeApplication": "Close application form",
  "priceChannel.startCertification": "Start certification",
  "priceChannel.noEnterpriseSubject":
    "This identity has no authorized enterprise subject and cannot apply for certification.",
  "priceChannel.certificationSubject": "Certification subject",
  "priceChannel.certificationType": "Certification type",
  "priceChannel.evidenceMaterials": "Evidence files",
  "priceChannel.evidencePickerHint":
    "Select from this account's visible file library, up to {max} files. Paths and URLs are not submitted.",
  "priceChannel.removeEvidence": "Remove evidence file {name}",
  "priceChannel.readingFiles": "Loading…",
  "priceChannel.refreshFiles": "Refresh file library",
  "priceChannel.fileLibraryHint":
    "Use completed files in your account's file library; do not send paths or URLs. Up to 20 files.",
  "priceChannel.noFiles":
    "No eligible files are available. Upload one to your personal file library first.",
  "priceChannel.fileNumber": "File {id}",
  "priceChannel.submitting": "Submitting…",
  "priceChannel.submitCertification": "Submit certification application",
  "priceChannel.readingCertifications": "Loading certifications…",
  "priceChannel.noCertifications": "No certification applications yet.",
  "priceChannel.applicationNumber": "Application {id}",
  "priceChannel.viewReviewHistory": "View review history",
  "priceChannel.currentStage": "Current stage: {stage}",
  "priceChannel.awaitProcessing": "Awaiting processing",
  "priceChannel.noReviewEvent": "No review events yet.",
  "priceChannel.noOpinion": "No note provided",
  "priceChannel.certificationReadFailed": "Could not load certifications",
  "priceChannel.filesReadFailed": "Could not load the file library",
  "priceChannel.certificationRequired":
    "Select an authorized subject, certification type and 1–20 evidence files",
  "priceChannel.certificationSaved":
    "Certification application saved to the business system.",
  "priceChannel.certificationFailed": "Certification application failed",
  "priceChannel.reviewHistoryReadFailed": "Could not load review history",
  "priceChannel.reviewResults": "Review Results",
  "priceChannel.noReviewResult": "No reviewed records for this type yet.",
  "priceChannel.resultListIncomplete":
    "The review-result list is incomplete. Please retry later.",
  "priceChannel.resultLinkInvalid":
    "The review-result link has an invalid type or business ID; legacy demo IDs are not mapped yet.",
  "priceChannel.resultDetailIncomplete":
    "The result detail lacks its original content or review timeline and cannot be shown safely.",
  "priceChannel.reviewResultsDescription":
    "Review completed enterprise certifications, product submissions and part-number submissions in one place.",
  "priceChannel.reviewResultTypes": "Review result types",
  "priceChannel.reviewResultsFor": "{type} review results",
  "priceChannel.noReviewResultsFor": "No completed {type} review results",
  "priceChannel.closeDetail": "Close details",
  "priceChannel.statusTimeline": "Status Timeline",
  "priceChannel.resultGroup.certification": "Enterprise certification",
  "priceChannel.resultGroup.product": "Product submission",
  "priceChannel.resultGroup.part-number": "Part-number submission",
  "priceChannel.backToCategory": "Back to {name}",
  "priceChannel.profileSections": "Market profile sections",
  "priceChannel.sectionNav.market": "Trend",
  "priceChannel.sectionNav.spec": "Part Numbers",
  "priceChannel.sectionNav.comparison": "Markets",
  "priceChannel.sectionNav.overview": "Overview",
  "priceChannel.sectionNav.events": "Events",
  "priceChannel.sectionNav.research": "Research",
  "priceChannel.sectionNav.sources": "Sources",
  "priceChannel.compositeTrend": "Composite Trend and Source Observations",
  "priceChannel.timeRange": "Market time range",
  "priceChannel.inventoryTitle": "Part Numbers and Inventory Batches",
  "priceChannel.partBackground": "Part Numbers and Specification Context",
  "priceChannel.noPublishedParts": "No published part numbers",
  "priceChannel.publishedPartsHint":
    "The product profile is published. Approved part numbers, inventory batches and quotes will appear here automatically.",
  "priceChannel.objectLevel": "Object level",
  "priceChannel.objectLevelHint":
    "This object groups one standard specification. Refer to public part-number records for specific items.",
  "priceChannel.trendBoundary": "Trend input criteria",
  "priceChannel.trendBoundaryHint":
    "Only observations with aligned specifications, sources and time basis contribute to the trend.",
  "priceChannel.specificParts": "Specific part numbers",
  "priceChannel.partLoadRetry":
    "Part numbers could not be loaded. Click to retry",
  "priceChannel.partPreparing": "Preparing part-number information…",
  "priceChannel.marketRelated": "Related Markets",
  "priceChannel.industryRelated": "Industry-related",
  "priceChannel.relatedLoadRetry":
    "Related markets could not be loaded. Click to retry",
  "priceChannel.relatedPreparing": "Preparing related markets…",
  "priceChannel.noRelatedMarkets": "No related markets",
  "priceChannel.relatedHint":
    "The product facts are public. Related products and parent markets will appear when available.",
  "priceChannel.productOverview": "Product and Specification Overview",
  "priceChannel.productIndex": "Product Index",
  "priceChannel.brandProfile": "{brand} brand profile",
  "priceChannel.brand": "Brand",
  "priceChannel.productKind": "Product category / subtype",
  "priceChannel.standardSpecification": "Standard specification",
  "priceChannel.representativePart": "Representative part number",
  "priceChannel.trendBasis": "Trend basis",
  "priceChannel.application": "Applications",
  "priceChannel.latestIndex": "Latest index",
  "priceChannel.sevenDayChange": "7-day change",
  "priceChannel.dailyChange": "Daily change",
  "priceChannel.sevenDayBasis":
    "Current index relative to the previous close in the 7D range",
  "priceChannel.totalSamples": "Total samples",
  "priceChannel.anonymizedSources": "{count} anonymized source classes",
  "priceChannel.marketEvents": "Market Events",
  "priceChannel.research": "Research and Announcements",
  "priceChannel.researchItem.0.title": "Market Summary",
  "priceChannel.researchItem.0.detail":
    "A local summary of the fixed 30-day series, sample coverage and differences among comparable products.",
  "priceChannel.researchItem.1.title": "Specification Summary",
  "priceChannel.researchItem.1.detail":
    "Public specifications such as representative part number, package, speed and yield.",
  "priceChannel.researchItem.2.title": "Source Announcements",
  "priceChannel.researchItem.2.detail":
    "A place for authorized source announcements and public references after launch.",
  "priceChannel.sourceCoverage": "Source Coverage",
  "priceChannel.sourceLoadRetry": "Sources could not be loaded. Click to retry",
  "priceChannel.sourcePreparing": "Preparing source coverage…",
  "priceChannel.profileCompanyMark": "Product profile company mark",
  "priceChannel.profileEnd": "PRICE INDEX · End of profile",
  "priceChannel.profileEndHint": "Traceable data · End of DEMO profile",
  "priceChannel.detailLoading": "Loading market details",
  "priceChannel.temporaryCard": "Temporary browser trend card {id}",
  "priceChannel.temporaryHint":
    "This card is for a local Demo only and is not a published market release.",
  "priceChannel.cardSpecification": "Card and Standard Specifications",
  "priceChannel.trendSummary": "Trend Summary",
  "priceChannel.trendSummaryHint":
    "Public market fields from the local Demo data.",
  "priceChannel.instrumentNotFound": "Market instrument not found",
  "priceChannel.instrumentNotFoundHint":
    "The instrument ID is invalid or this object does not exist in the current Demo data.",
  "priceChannel.trendNoPublishedSamples":
    "The product profile is published, but no trend samples can be calculated yet",
  "priceChannel.trendNoData": "No trend data is available at the moment",
  "priceChannel.chartUnit": "Trend index (base=100)",
  "priceChannel.spec.technology": "Product type",
  "priceChannel.spec.density": "Single-chip capacity",
  "priceChannel.spec.dataWidth": "Data width",
  "priceChannel.spec.organization": "Organization",
  "priceChannel.spec.die": "Die",
  "priceChannel.spec.speed": "Grade",
  "priceChannel.spec.timing": "Rated timing",
  "priceChannel.spec.package": "Package",
  "priceChannel.spec.dieStack": "Die stack",
  "priceChannel.spec.voltage": "Operating voltage",
  "priceChannel.spec.temperature": "Operating temperature",
  "priceChannel.temporarySpec.cardTitle": "Card title",
  "priceChannel.temporarySpec.cardSpec": "Card specification",
  "priceChannel.temporarySpec.fullPart": "Full part number",
  "priceChannel.temporarySpec.application": "Applications",
  "priceChannel.temporarySpec.lifecycle": "Lifecycle",
  "priceChannel.temporarySpec.validUntil": "Data valid until",
  "priceChannel.notProvided": "Not provided",
  "priceChannel.sidebar.publicProductCategories":
    "Public market product categories",
  "priceChannel.sidebar.searchBrand": "Search brands",
  "priceChannel.sidebar.brandInitials": "Filter {name} by initial",
  "priceChannel.sidebar.noBrands": "No matching brands",
  "priceChannel.sidebar.searchTechnicalFamily":
    "Search categories and technology families",
  "priceChannel.sidebar.publicCategories":
    "Public market categories and subcategories",
  "priceChannel.sidebar.subcategories": "{name} subcategories",
  "priceChannel.sidebar.noTechnicalFamilies": "No matching technology families",
  "priceChannel.operations.title": "Manual review of products and part numbers",
  "priceChannel.operations.pendingCount": "{count} pending items",
  "priceChannel.operations.filter": "Filter operations reviews",
  "priceChannel.operations.tab.ALL": "All",
  "priceChannel.operations.tab.PRODUCT_FACT": "Product facts",
  "priceChannel.operations.tab.PART_NUMBER": "Standard part numbers",
  "priceChannel.operations.tab.INVENTORY_BATCH": "Inventory batches",
  "priceChannel.operations.tab.QUOTE_OBSERVATION": "Quote observations",
  "priceChannel.operations.tab.ENGINEERING_RETURN": "Engineering returns",
  "priceChannel.operations.publicProfile": "Complete public product profile",
  "priceChannel.operations.completeProfile":
    "Add required category-detail information",
  "priceChannel.operations.autofill": "Autofill",
  "priceChannel.operations.profileBoundary":
    "Part numbers, inventory and quotes are maintained separately under part-number submissions.",
  "priceChannel.operations.brandDisplayName": "Brand display name",
  "priceChannel.operations.subcategory": "Product subtype",
  "priceChannel.operations.lifecycle": "Lifecycle",
  "priceChannel.operations.summary": "Product description",
  "priceChannel.operations.saveProfile": "Save profile details",
  "priceChannel.operations.saveBeforeApprove":
    "Save all required details before approval and public category listing.",
  "priceChannel.operations.opinionPlaceholder":
    "Give a reason for approval, return or rejection",
  "priceChannel.operations.startReview": "Start review",
  "priceChannel.operations.requestChanges": "Request changes",
  "priceChannel.operations.noMatching": "No pending items in this filter",
  "priceChannel.operations.productFolder": "Product folder",
  "priceChannel.operations.partIntake": "Part-number intake",
  "priceChannel.operations.reviewStarted": "Product review started",
  "priceChannel.operations.autofillReady":
    "A Demo public profile was generated. Click again to switch variants",
  "priceChannel.operations.profileSaved": "Public product profile saved",
  "priceChannel.operations.profileForbidden":
    "This identity cannot complete this public product profile",
  "priceChannel.operations.profileIncomplete":
    "Public product profile is incomplete",
  "priceChannel.operations.opinionRequired": "Enter a review note first",
  "priceChannel.operations.opinionTooLong":
    "Review note must be no more than 25 characters",
  "priceChannel.operations.notPublishable":
    "This record is not ready for publication",
  "priceChannel.operations.reviewUnavailable": "This record cannot be reviewed",
  "priceChannel.operations.approved":
    "Operations approved; Demo data published",
  "priceChannel.operations.saved": "Operations review result saved",
  "priceChannel.catalog.draftChanged":
    "The product draft changed. Refresh and try again",
  "priceChannel.messages.visibleSubmissions": "{count} visible submissions",
  "priceChannel.messages.ready": "Ready to process",
  "priceChannel.messages.workflow.certification-review.title":
    "Enterprise certifications to review",
  "priceChannel.messages.workflow.certification-review.detail":
    "Brand owners and marketplaces submit their applications for operations review",
  "priceChannel.messages.workflow.operations-review.title":
    "Operations reviews to process",
  "priceChannel.messages.workflow.operations-review.detail":
    "Review product facts, part numbers, stock batches and quotes in one workspace",
  "priceChannel.messages.workflow.part-number-submit.title":
    "Submit part numbers",
  "priceChannel.messages.workflow.part-number-submit.detail":
    "Add part numbers to existing or new products, then manage stock batches and quotes",
  "priceChannel.messages.workflow.product-submit.title": "Submit products",
  "priceChannel.messages.workflow.product-submit.detail":
    "Create a basic product profile without part numbers, stock or quotes",
  "priceChannel.quote.folderHint":
    "Part numbers, inventory and quotes in the product folder",
  "priceChannel.quote.headingStatus":
    "Business submission · Published after operations review",
  "priceChannel.quote.combineObject": "Quote combination",
  "priceChannel.quote.chooseProduct": "Select a product",
  "priceChannel.quote.channel": "Quote channel",
  "priceChannel.quote.chooseSource": "Select a quote source",
  "priceChannel.quote.partMode": "Part-number operation mode",
  "priceChannel.quote.followPart": "Follow up on part number",
  "priceChannel.quote.newPart": "Add part number",
  "priceChannel.quote.chooseExistingPart": "Select an existing part number",
  "priceChannel.quote.newPartHint":
    "A unique part number will be created with this intake",
  "priceChannel.quote.batchMode": "Inventory batch operation mode",
  "priceChannel.quote.followBatch": "Follow up on batch",
  "priceChannel.quote.newBatch": "Add batch",
  "priceChannel.quote.chooseExistingBatch": "Select an existing batch",
  "priceChannel.quote.newBatchHint":
    "A new inventory batch will be created with this intake",
  "priceChannel.quote.regenerate": "Generate another quote set",
  "priceChannel.quote.generate": "Generate quote intake",
  "priceChannel.quote.currentCombination": "Current combination",
  "priceChannel.quote.channelShort": "Channel",
  "priceChannel.quote.batchShort": "Batch",
  "priceChannel.quote.batchHistory": "Batch quote history",
  "priceChannel.quote.noPublishedQuotes":
    "No published quotes for this inventory batch yet",
  "priceChannel.quote.intakeAndAi": "Current intake and AI pre-parse",
  "priceChannel.quote.rawIntake": "Original quote intake",
  "priceChannel.quote.time": "Quote time",
  "priceChannel.quote.stockMoq": "Stock / MOQ",
  "priceChannel.quote.tierPrices": "Tier prices",
  "priceChannel.quote.tiers": "{count} tiers",
  "priceChannel.quote.aiPreparse": "AI pre-parse",
  "priceChannel.quote.demoCandidate": "Demo candidate",
  "priceChannel.quote.correctedValue": "Corrected value for {name}",
  "priceChannel.quote.regenerateCandidate": "Regenerate candidate for {name}",
  "priceChannel.quote.currentDecision": "{name} is currently {status}",
  "priceChannel.quote.cycleDecision":
    "Switch {name} between confirm, correct and reset",
  "priceChannel.quote.stableMapping": "Stable mapping",
  "priceChannel.quote.confirmUpload": "Confirm upload and send to operations",
  "priceChannel.quote.notGenerated": "No intake generated yet",
  "priceChannel.quote.generateHint":
    "Choose a combination on the left, then generate the quote and AI pre-parse result.",
  "priceChannel.quote.decision.ACCEPTED": "Confirm",
  "priceChannel.quote.decision.CORRECTED": "Correct",
  "priceChannel.quote.decision.REGENERATED": "Reset",
  "priceChannel.quote.notSelected": "Not selected",
  "priceChannel.quote.autoGenerate": "Generated automatically",
  "priceChannel.quote.withNewBatch": "Generated with the new batch",
  "priceChannel.quote.generated":
    "Quote and AI pre-parse result generated for this combination",
  "priceChannel.quote.correctedRequired":
    "Corrected value for {name} is required",
  "priceChannel.quote.timePending": "Time pending",
  "priceChannel.quote.quantityUnknown": "Quantity unknown",
  "priceChannel.quote.confirmFields": "Confirm the AI-parsed fields first",
  "priceChannel.quote.sourceForbidden":
    "This identity cannot submit quotes for this source",
  "priceChannel.quote.submitted":
    "Upload confirmation saved and sent to operations review",
  "priceChannel.brandArchive": "Brand profile",
  "priceChannel.brandCounts":
    "{categories} business categories · {products} related products",
  "priceChannel.regionalMarketCaveat":
    "Recalculated by quote-source region; not a local transaction price. Each category is calculated separately.",
  "priceChannel.marketObservation": "Market Observations",
  "priceChannel.brandMarketLevel": "Level {level} brand market",
  "priceChannel.productRelated": "Related Products",
  "priceChannel.openMarketArchive": "View market profile for {name}",
  "priceChannel.sevenDayCompositeSparkline": "7-day composite trend for {name}",
  "priceChannel.sevenDayMarketSparkline": "7-day market trend for {name}",
  "priceChannel.defaultMarketSparkline": "7-day market trend preview",
  "priceChannel.demo": "Demo",
  "priceChannel.approvedProductCount": "{count} reviewed products",
  "priceChannel.coverageCounts":
    "{categories} categories · {products} products",
  "priceChannel.related.parent": "Parent markets",
  "priceChannel.related.peer": "Peer markets",
  "priceChannel.related.child": "Child markets",
  "priceChannel.related.peerAndParent": "Peer and parent markets",
  "priceChannel.spotBoard.title":
    "Market board for the current product category",
  "priceChannel.spotBoard.favorite": "Favorite",
  "priceChannel.spotBoard.model": "Product model",
  "priceChannel.spotBoard.index": "Index",
  "priceChannel.spotBoard.sevenDay": "7 days",
  "priceChannel.spotBoard.recentRange": "Last 7 points high / low",
  "priceChannel.spotBoard.samplesSources": "Samples / sources",
  "priceChannel.spotBoard.trend": "Trend chart",
  "priceChannel.spotBoard.sourceSummary":
    "{samples} samples, {sources} sources, {detail}",
  "priceChannel.personal.readOnly": "Read-only mode",
  "priceChannel.personal.viewCertification": "View certification",
  "priceChannel.personal.timelineLabel":
    "Submission, review and publication timeline; latest item on the left",
  "priceChannel.personal.noTimelineEvents": "No submission events recorded yet",
  "priceChannel.personal.noEventTime": "Time not recorded",
  "priceChannel.personal.messageDescription":
    "Market updates, part-number inventory, business items and system notices are grouped by the current Demo account.",
  "priceChannel.personal.filter.ALL": "All",
  "priceChannel.personal.filter.UNREAD": "Unread",
  "priceChannel.personal.messageCategories": "Message categories",
  "priceChannel.personal.category.ALL": "All",
  "priceChannel.personal.category.MARKET": "Market watchlist",
  "priceChannel.personal.category.INVENTORY": "Part numbers / inventory",
  "priceChannel.personal.category.WORKFLOW": "Business workflow",
  "priceChannel.personal.category.SYSTEM": "System",
  "priceChannel.personal.businessItems": "Business items",
  "priceChannel.personal.openRelated": "Open related item",
  "priceChannel.personal.markRead": "Mark as read",
  "priceChannel.personal.noMessages": "No matching messages",
  "priceChannel.personal.submissionHistory": "Submission History",
  "priceChannel.personal.coreSpecs": "Key specifications",
  "priceChannel.personal.collapseDetails": "Collapse details",
  "priceChannel.personal.expandDetails": "Expand details",
  "priceChannel.personal.initialDraftTime": "Initial draft: {time}",
  "priceChannel.personal.formalSubmit": "Submit formally",
  "priceChannel.personal.noVisibleSubmissions": "No visible submissions",
  "priceChannel.personal.submissionHint":
    "Product and part-number submissions will show their operations review status here.",
  "priceChannel.personal.productBasicProfile": "Basic product profile",
  "priceChannel.personal.moreSpecs": "{values}, etc.",
  "priceChannel.personal.productReadOnly":
    "This identity or enterprise certification cannot create a product submission.",
  "priceChannel.personal.autofillV5": "Autofill a V5 example",
  "priceChannel.personal.productDisplayName": "Product display name",
  "priceChannel.personal.stableBrand": "Stable brand",
  "priceChannel.personal.technicalDimensions": "Technical dimensions",
  "priceChannel.personal.v5Dimensions": "V5 product dimensions",
  "priceChannel.personal.reset": "Reset",
  "priceChannel.personal.submitToOperations": "Submit to operations review",
  "priceChannel.personal.nameRequired": "Enter a product display name",
  "priceChannel.personal.categoryRequired": "Select a primary category",
  "priceChannel.personal.brandRequired": "Select a stable brand",
  "priceChannel.personal.dimensionRequired": "Select {name}",
  "priceChannel.statusTag.UNVERIFIED": "Unverified",
  "priceChannel.statusTag.DRAFT": "Draft",
  "priceChannel.statusTag.SUBMITTED": "Submitted",
  "priceChannel.statusTag.UNDER_REVIEW": "Under review",
  "priceChannel.statusTag.DEPARTMENT_APPROVED": "Awaiting leadership review",
  "priceChannel.statusTag.CHANGES_REQUESTED": "Changes requested",
  "priceChannel.statusTag.REJECTED": "Rejected",
  "priceChannel.statusTag.APPROVED": "Approved",
  "priceChannel.statusTag.PUBLISHED": "Published",
  "priceChannel.statusTag.EXPIRED": "Expired",
  "priceChannel.statusTag.REVOKED": "Revoked",
  "priceChannel.profile.title": "Company profile",
  "priceChannel.profile.hint":
    "Company identity, supply capabilities and contacts.",
  "priceChannel.profile.preview": "Preview public profile",
  "priceChannel.profile.summary": "Company profile summary",
  "priceChannel.profile.completeness": "Profile completeness",
  "priceChannel.profile.completenessHint": "Based on required sections",
  "priceChannel.profile.status": "Profile status",
  "priceChannel.profile.statusHint": "Saving does not advance the status",
  "priceChannel.profile.approvedQualifications": "Approved qualifications",
  "priceChannel.profile.qualificationHint":
    "Complete versions appear in the library",
  "priceChannel.profile.organization": "Company identity",
  "priceChannel.profile.displayName": "Display name",
  "priceChannel.profile.shortName": "Short name",
  "priceChannel.profile.region": "Region",
  "priceChannel.profile.supplierCode": "Demo supplier code",
  "priceChannel.profile.organizationId": "Organization ID",
  "priceChannel.profile.parentOrganization": "Parent/subsidiary relationship",
  "priceChannel.profile.description": "Company summary",
  "priceChannel.profile.capabilities": "Supply capabilities",
  "priceChannel.profile.productFamilies": "Product families",
  "priceChannel.profile.brandManufacturers": "Brands/manufacturers",
  "priceChannel.profile.applications": "Applications",
  "priceChannel.profile.supplyRegions": "Supply regions",
  "priceChannel.profile.commonMoq": "Typical MOQ",
  "priceChannel.profile.leadTime": "Typical lead time",
  "priceChannel.profile.stockConditions": "Stock conditions",
  "priceChannel.profile.contacts": "Contacts",
  "priceChannel.profile.defaultContact": "Default",
  "priceChannel.profile.materialSummary": "Certification materials",
  "priceChannel.profile.openLibrary": "Open library",
  "priceChannel.profile.savedLocally":
    "Draft saved on this page; it has not been sent to the server.",
  "priceChannel.profile.saveDraft": "Save local draft",
  "priceChannel.profile.readOnly": "Read-only identity",
  "priceChannel.profile.noOrganization":
    "No company is available to this identity",
  "priceChannel.profile.publicPreview": "Public company profile preview",
  "priceChannel.profile.publicPreviewHint":
    "Only approved, published and explicitly public fields are shown.",
  "priceChannel.profile.backToProfile": "Back to company profile",
  "priceChannel.profile.publicProfile": "Public company profile",
  "priceChannel.profile.brands": "Brands covered",
  "priceChannel.profile.notPublic":
    "This profile has not been approved and published",
  "priceChannel.qualification.title": "Qualification documents",
  "priceChannel.qualification.hint":
    "Only redacted attachment metadata is kept; replacing a version preserves history.",
  "priceChannel.qualification.type": "Document type",
  "priceChannel.qualification.allTypes": "All types",
  "priceChannel.qualification.reviewStatus": "Review status",
  "priceChannel.qualification.allStatuses": "All statuses",
  "priceChannel.qualification.versions": "Document versions",
  "priceChannel.qualification.count": "{count} records",
  "priceChannel.qualification.effectivePeriod": "Valid period",
  "priceChannel.qualification.selectedAt": "Selected at",
  "priceChannel.qualification.linkedProducts": "Linked products",
  "priceChannel.qualification.noLinkedProducts": "No linked products",
  "priceChannel.qualification.replacedVersion": "Replaced version",
  "priceChannel.qualification.firstVersion": "First version",
  "priceChannel.qualification.latestReturn": "Latest return: ",
  "priceChannel.qualification.empty":
    "No qualification documents match these filters",
  "priceChannel.qualification.createVersion": "Create a new draft version",
  "priceChannel.qualification.selectAttachment": "Choose a demo attachment",
  "priceChannel.qualification.noExtension": "No extension",
  "priceChannel.qualification.noFile":
    "No file selected; its contents will not be read.",
  "priceChannel.qualification.readOnly":
    "This identity is read-only and cannot create a document version.",
  "priceChannel.qualification.saveDraft": "Save as a new draft version",
  "priceChannel.qualification.saved":
    "A new qualification version was created as a shared draft.",
  "priceChannel.certCenter.title": "Company certification",
  "priceChannel.certCenter.hint":
    "Company identity, brand and authorization reviews have department and leadership stages.",
  "priceChannel.certCenter.resetDemo": "Reset certification demo",
  "priceChannel.certCenter.leaderReview":
    "Certification progress and final review",
  "priceChannel.certCenter.departmentReview": "Department certification review",
  "priceChannel.certCenter.noReview":
    "There are no company certifications awaiting review.",
  "priceChannel.certCenter.currentSubject": "Current certified company",
  "priceChannel.certCenter.legalName": "Legal company name",
  "priceChannel.certCenter.creditCode": "Unified social credit code",
  "priceChannel.certCenter.contact": "Contact",
  "priceChannel.certCenter.validUntil": "Valid until",
  "priceChannel.certCenter.scope": "Certification scope",
  "priceChannel.certCenter.applicationProgress": "Application progress",
  "priceChannel.certCenter.applicationMaterials":
    "Materials for this application",
  "priceChannel.certCenter.noCertification":
    "No company certification record exists for this organization",
  "priceChannel.certCenter.start": "Start certification",
  "priceChannel.certCenter.notApplicable":
    "Certification does not apply to this identity",
  "priceChannel.certCenter.roleHint":
    "{role} uses internal authorization or public read-only access and does not create an external certification. Certification is for own brands and authorized platforms.",
  "priceChannel.certCenter.demoDisclaimer":
    "All companies, materials, statuses, reviews and validity dates on this page are local browser demo data, not real certification or authorization.",
  "priceChannel.certCenter.registeredAddress": "Registered address",
  "priceChannel.certCenter.website": "Company website",
  "priceChannel.certCenter.notProvided": "Not provided",
  "priceChannel.certCenter.contactPhone": "Contact phone",
  "priceChannel.certCenter.contactEmail": "Contact email",
  "priceChannel.certCenter.evidence": "Supporting document",
  "priceChannel.certCenter.productCategories": "Product categories",
  "priceChannel.certCenter.brands": "Brands",
  "priceChannel.certCenter.businessRegions": "Business regions",
  "priceChannel.certCenter.priceTypes": "Price types",
  "priceChannel.certCenter.businessDescription":
    "Business and data source description",
  "priceChannel.certMaterials.subject": "Company subject",
  "priceChannel.certMaterials.type": "Company type",
  "priceChannel.certMaterials.type.SELF_OWNED_BRAND": "Own brand",
  "priceChannel.certMaterials.type.AUTHORIZED_PLATFORM": "Authorized platform",
  "priceChannel.certMaterials.organizationId": "Organization ID",
  "priceChannel.certMaterials.contactSection": "Contact and business details",
  "priceChannel.certMaterials.businessDescription": "Business description",
  "priceChannel.certMaterials.scope": "Declared business scope",
  "priceChannel.certMaterials.evidenceCount": "Supporting files ({count})",
  "priceChannel.certMaterials.evidenceType": "File type:",
  "priceChannel.certMaterials.evidenceId": "Evidence ID:",
  "priceChannel.certMaterials.demoDigest": "Demo digest:",
  "priceChannel.certMaterials.noEvidence": "No supporting files submitted.",
  "priceChannel.certMaterials.reviewTrace": "Submission and review history",
  "priceChannel.certMaterials.certificationId": "Certification ID",
  "priceChannel.certMaterials.source": "Data source",
  "priceChannel.certMaterials.submittedAt": "Submitted at",
  "priceChannel.certMaterials.updatedAt": "Last updated",
  "priceChannel.certMaterials.departmentReview": "Operations review",
  "priceChannel.certMaterials.departmentOpinion": "Operations note",
  "priceChannel.certMaterials.leaderReview": "Leadership review",
  "priceChannel.certMaterials.leaderOpinion": "Leadership note",
  "priceChannel.certMaterials.validFrom": "Valid from",
  "priceChannel.certMaterials.notFilled": "Not provided",
  "priceChannel.certMaterials.notOccurred": "Not yet occurred",
  "priceChannel.certMaterials.listSeparator": ", ",
  "priceChannel.certMaterials.fixture": "Frozen fixture",
  "priceChannel.certMaterials.browserJson": "Temporary browser JSON",
  "priceChannel.certMaterials.evidence.BUSINESS_LICENSE": "Business license",
  "priceChannel.certMaterials.evidence.BRAND_OWNERSHIP":
    "Brand ownership document",
  "priceChannel.certMaterials.evidence.CHANNEL_AUTHORIZATION":
    "Channel authorization document",
  "priceChannel.certMaterials.evidence.OTHER": "Other supporting document",
  "priceChannel.certMaterials.evidenceStatus.PENDING": "Pending verification",
  "priceChannel.certMaterials.evidenceStatus.NEEDS_REVIEW":
    "Needs manual review",
  "priceChannel.certMaterials.evidenceStatus.ACCEPTED": "Accepted",
  "priceChannel.certMaterials.evidenceStatus.REJECTED": "Rejected",
  "priceChannel.certMaterials.status.UNVERIFIED": "Demo: unverified",
  "priceChannel.certMaterials.status.DRAFT": "Draft awaiting submission",
  "priceChannel.certMaterials.status.SUBMITTED": "Submitted",
  "priceChannel.certMaterials.status.UNDER_REVIEW": "Under department review",
  "priceChannel.certMaterials.status.DEPARTMENT_APPROVED":
    "Department approved",
  "priceChannel.certMaterials.status.CHANGES_REQUESTED":
    "Additional information requested",
  "priceChannel.certMaterials.status.APPROVED": "Demo: certified",
  "priceChannel.certMaterials.status.REJECTED": "Demo: rejected",
  "priceChannel.certMaterials.status.SUSPENDED": "Demo: suspended",
  "priceChannel.certMaterials.status.EXPIRED": "Demo: expired",
  "priceChannel.certTimeline.aria": "Certification review timeline",
  "priceChannel.certTimeline.opinion": "Review note: {opinion}",
  "priceChannel.certTimeline.stage.submitter": "Applicant submitted",
  "priceChannel.certTimeline.stage.operations": "Operations review",
  "priceChannel.certTimeline.stage.leader": "Leadership review",
  "priceChannel.certTimeline.stageExtra": "Review stage {number}",
  "priceChannel.submissionDetail.title": "Submission details",
  "priceChannel.submissionDetail.unknown": "Unknown submission",
  "priceChannel.submissionDetail.back": "Back to submissions",
  "priceChannel.submissionDetail.version": "Version {version}",
  "priceChannel.submissionDetail.productName": "Product name",
  "priceChannel.submissionDetail.fullPartNumber": "Full part number",
  "priceChannel.submissionDetail.normalizedPartNumber":
    "Normalized part number",
  "priceChannel.submissionDetail.dimensions": "Version 5 dimensions",
  "priceChannel.submissionDetail.reviewTimeline": "Review timeline",
  "priceChannel.submissionDetail.notFound":
    "Submission not found or outside the current scope",
  "priceChannel.eventTimeline.empty": "No status events yet",
  "priceChannel.rangeMore.more": "More",
  "priceChannel.rangeMore.aria": "Custom market index range",
  "priceChannel.rangeMore.timezone": "Enter times in Beijing time (UTC+8)",
  "priceChannel.rangeMore.invalid":
    "Invalid time range or outside the current release",
  "priceChannel.legacySurface.company": "Company profile",
  "priceChannel.legacySurface.qualifications": "Qualification library",
  "priceChannel.legacySurface.company-preview": "Public company profile",
  "priceChannel.legacySurface.unavailable":
    "This entry is preserved, but the formal company profile, qualification library and public profile APIs are not connected. Demo data is not shown here.",
  "priceChannel.legacySurface.certifications":
    "View connected enterprise certification",
  "priceChannel.rangeMore.start": "Start time",
  "priceChannel.rangeMore.end": "End time",
  "priceChannel.rangeMore.granularity": "Granularity",
  "priceChannel.rangeMore.minute": "Minute",
  "priceChannel.rangeMore.hour": "Hour",
  "priceChannel.rangeMore.day": "Day",
  "priceChannel.rangeMore.week": "Week",
  "priceChannel.rangeMore.month": "Month",
  "priceChannel.rangeMore.step": "Interval",
  "priceChannel.rangeMore.hint":
    "Minute-level data is for demo sampling only, up to 90 points.",
  "priceChannel.rangeMore.apply": "Apply range",
  "priceChannel.record.quoteObject": "Quote combination",
  "priceChannel.record.quoteChannel": "Quote channel",
  "priceChannel.record.inventoryBatch": "Inventory batch",
  "priceChannel.record.currentCombination": "Current combination",
  "priceChannel.record.latestQuote": "Latest quote",
  "priceChannel.record.quoteTime": "Quote time",
  "priceChannel.record.inventoryMoq": "Inventory / MOQ",
  "priceChannel.record.packageCondition": "Packaging / condition",
  "priceChannel.record.tierCount": "{count} tiers",
  "priceChannel.record.batchHistory": "Batch quote history",
  "priceChannel.record.noBatchHistory":
    "No published quotes for this inventory batch yet",
  "priceChannel.record.intakeAndAi": "Current intake and AI pre-analysis",
  "priceChannel.record.primaryCategory": "Primary category",
  "priceChannel.record.technologyFamily": "Technology family",
  "priceChannel.record.uploaderConfirmation": "Uploader confirmation",
  "priceChannel.record.confirmedAt": "Confirmed at",
  "priceChannel.record.channelPartMapping": "Channel part-number mapping",
  "priceChannel.record.noAiResult":
    "No AI pre-analysis was saved for this intake",
  "priceChannel.record.productIdentity": "Product identity",
  "priceChannel.record.productDescription": "Product description",
  "priceChannel.record.noProductFacts":
    "This history record has no saved base product facts",
  "priceChannel.record.unlinkedProduct": "Product not linked",
  "priceChannel.record.pendingGeneration": "Pending generation",
  "priceChannel.record.unlinkedChannel": "Channel not linked",
  "priceChannel.record.pendingRecognition": "Pending recognition",
  "priceChannel.record.confirmed": "Confirmed",
  "priceChannel.record.reconfirm": "Needs reconfirmation",
  "priceChannel.record.pendingMapping": "Pending mapping",
  "priceChannel.record.mapped": "Mapped",
  "priceChannel.record.pendingReview": "Pending review",
  "priceChannel.dimensionTrackAria": "Market dimension track",
  "priceChannel.certReview.collapse": "Collapse",
  "priceChannel.certReview.expand": "Expand",
  "priceChannel.certReview.disclosureAria":
    "{action} certification materials for {name}",
  "priceChannel.certReview.materialsAria": "Certification materials for {name}",
  "priceChannel.certReview.waitingForOperations":
    "Operations review is in progress. The leader may inspect all materials but cannot make a final decision yet.",
  "priceChannel.certReview.readyForFinal":
    "Operations approved. The leader can now complete the final review.",
  "priceChannel.certReview.opinion": "Review note",
  "priceChannel.certReview.opinionAria": "Review note for {name}",
  "priceChannel.certReview.waitingPlaceholder": "Waiting for operations review",
  "priceChannel.certReview.reasonPlaceholder":
    "Give a reason for approval, return or rejection",
  "priceChannel.certReview.disabledTitle":
    "Available after operations approval",
  "priceChannel.certReview.finalApprove": "Final approval",
  "priceChannel.certReview.departmentApprove": "Department approval",
  "priceChannel.certReview.returnMaterials": "Request more materials",
  "priceChannel.certReview.notProvided": "Not provided",
  "priceChannel.certReview.opinionRequired": "Enter a review note first",
  "priceChannel.account.currentIdentity": "Current price-channel identity",
  "priceChannel.account.openMessages": "Open message center",
  "priceChannel.account.messages": "Message center",
  "priceChannel.account.debugAccount": "Demo account",
  "priceChannel.account.selectRoleGroup": "Select role group",
  "priceChannel.account.selectDepartment": "Select department",
  "priceChannel.account.switchMember": "Switch member",
  "priceChannel.account.selectIdentity": "Select business identity",
  "priceChannel.api.localTargetRequired":
    "Set VUE_APP_MTS_API_TARGET to the local Spring Boot service before testing",
  "priceChannel.api.requestFailed":
    "The price-channel request could not be completed. Try again later",
  "priceChannel.api.unknownReviewAction": "Unknown review action",
  "priceChannel.api.error.UNAUTHENTICATED": "Please sign in first",
  "priceChannel.api.error.FORBIDDEN":
    "This identity cannot perform that action",
  "priceChannel.api.error.NOT_FOUND": "The requested item was not found",
  "priceChannel.api.error.RELEASE_EXPIRED":
    "This market release has expired. Refresh to view the latest version",
  "priceChannel.api.error.INVALID_ARGUMENT": "Invalid request",
  "priceChannel.api.error.VERSION_CONFLICT":
    "The version has changed. Refresh and try again",
  "priceChannel.api.error.IDEMPOTENCY_CONFLICT":
    "The same request key was used with different content",
  "priceChannel.api.error.PRICE_CHANNEL_UNAVAILABLE":
    "The price-channel service is temporarily unavailable",
});

// 共用行情组件
export const sharedComponents = Object.freeze({
  "marketComponents.search": "Search",
  "marketComponents.searchPlaceholder": "Enter a search term",
  "marketComponents.viewProduct": "View product: {title}",
  "marketComponents.unnamedProduct": "Unnamed product",
  "marketComponents.productImage": "Product image",
  "marketComponents.featured": "Featured",
  "marketComponents.buy": "Buy",
  "marketComponents.brand": "Brand",
  "marketComponents.partNumber": "Part number",
  "marketComponents.type": "Type",
  "marketComponents.capacity": "Capacity",
  "marketComponents.architecture": "Architecture",
  "marketComponents.speed": "Speed",
  "marketComponents.ballCount": "Ball count",
  "marketComponents.price": "Price",
  "marketComponents.quantity": "Quantity",
  "marketComponents.publisher": "Posted by",
  "marketComponents.priceOnRequest": "Price on request",
  "marketComponents.totalAmount": "Total ¥{amount}",
  "marketComponents.payCommission": "Pay commission",
  "marketComponents.requestCancel": "Request cancellation",
  "marketComponents.confirmReceipt": "Confirm receipt",
  "marketComponents.review": "Review",
  "marketComponents.currencyUnit": "Currency",
  "marketComponents.chooseCurrencyUnit": "Choose a price currency",
  "marketComponents.usDollar": "US dollar",
  "marketComponents.yuan": "Chinese yuan",
});

export const messages = Object.freeze({
  ...businessDisplay,
  ...market,
  ...sharedComponents,
});

// 系统技术分类显示名；不修改原始分类与查询标识
export const catalogLabels = Object.freeze({
  晶圆: "Wafers",
  IC芯片: "IC components",
  模组成品: "Modules and finished products",
  技术族: "Technology family",
  类型: "Type",
  制程: "Process",
  代际: "Generation",
  容量: "Capacity",
  频率: "Frequency",
  速率: "Speed",
  位宽: "Bus width",
  组织: "Organization",
  层数: "Layers",
  直径: "Diameter",
  封装: "Package",
  结构: "Structure",
  协议: "Protocol",
  接口: "Interface",
  形态: "Form factor",
  等级: "Grade",
  闪存晶圆: "Flash wafer",
  内存晶圆: "Memory wafer",
  闪存芯片: "Flash chip",
  内存芯片: "Memory chip",
  嵌入式存储: "Embedded storage",
  嵌入式存储器: "Embedded storage",
  固态硬盘: "Solid-state drive",
  内存条: "Memory module",
  存储卡: "Memory card",
  闪存卡: "Flash memory card",
  U盘: "USB flash drive",
  USB闪存盘: "USB flash drive",
  闪存盘: "Flash drive",
  其他SSD: "Other SSD",
  消费级: "Consumer",
  企业级: "Enterprise",
  工业级: "Industrial",
  二级市场: "Secondary market",
  高速: "High speed",
  不适用: "Not applicable",
  "2.5英寸": "2.5-inch",
  裸Die: "Bare die",
  封装颗粒: "Packaged IC",
  单Die: "Single die",
  多Die: "Multi-die",
  管理封装: "Managed package",
  TSV堆叠: "TSV stack",
  USB大容量存储: "USB mass storage",
});

// 冻结目录的机器代码显示名
export const catalogCodes = Object.freeze({
  "flash-wafer": "Flash wafer",
  "memory-wafer": "Memory wafer",
  "flash-chip": "Flash chip",
  "memory-chip": "Memory chip",
  "memory-module": "Memory module",
  "solid-state-drive": "Solid-state drive",
  "flash-card": "Flash memory card",
  "embedded-storage": "Embedded storage",
  "usb-flash-drive": "USB flash drive",
  ymtc: "YMTC",
  "protocol-version": "Protocol",
  "speed-class": "Speed class",
  "form-factor": "Form factor",
  "byte-capacity-gbyte": "Capacity",
  "interface-generation": "Interface",
  "ecc-capability": "ECC",
  "flash-cell-type": "Cell type",
  "wafer-device-kind": "Device type",
  "flash-memory-kind": "Flash type",
  "dram-generation": "Generation",
  "bit-density-gbit": "Density",
  "clock-mhz": "Clock",
  "data-rate-mtps": "Data rate",
  "bus-width": "Bus width",
  organization: "Organization",
  "stack-layer-count": "Layer count",
  "wafer-diameter-mm": "Diameter",
  "interface-rate-mtps": "Interface rate",
  package: "Package",
  "package-structure": "Structure",
  rank: "Rank",
  nvme: "NVMe",
  sata: "SATA",
  emmc: "eMMC",
  emcp: "eMCP",
  slc: "SLC",
  mlc: "MLC",
  tlc: "TLC",
  qlc: "QLC",
  "not-applicable": "Not applicable",
  ldpc: "LDPC",
  "sata-iii": "SATA III",
  "2.5-inch": "2.5-inch",
  consumer: "Consumer",
  enterprise: "Enterprise",
  industrial: "Industrial",
  "secondary-market": "Secondary market",
  "high-speed": "High speed",
  "bare-die": "Bare die",
  "packaged-ic": "Packaged IC",
  "single-die": "Single die",
  "multi-die": "Multi-die",
  "managed-package": "Managed package",
  "tsv-stack": "TSV stack",
  "usb-mass-storage": "USB mass storage",
  "unverified-white-batch": "Unverified white-chip scheme",
  "unverified-black-batch": "Unverified high-risk scheme",
});

// 已登记渠道展示参考译名；不是法定名称，未知企业保持原文
export const companyNames = Object.freeze({
  安庆存储通电子科技: "Anqing Cunchutong Electronics Technology",
  安庆科储半导体: "Anqing Kechu Semiconductor",
  安庆芯拓电子商贸: "Anqing Xintuo Electronics Trading",
  安庆芯源电子供应链: "Anqing Xinyuan Electronics Supply Chain",
  安阳存储通电子科技: "Anyang Cunchutong Electronics Technology",
  安阳科储半导体: "Anyang Kechu Semiconductor",
  安阳芯拓电子商贸: "Anyang Xintuo Electronics Trading",
  安阳芯源电子供应链: "Anyang Xinyuan Electronics Supply Chain",
  鞍山存储通电子科技: "Anshan Cunchutong Electronics Technology",
  鞍山芯拓电子商贸: "Anshan Xintuo Electronics Trading",
  鞍山芯源电子供应链: "Anshan Xinyuan Electronics Supply Chain",
  蚌埠存储通电子科技: "Bengbu Cunchutong Electronics Technology",
  蚌埠科储半导体: "Bengbu Kechu Semiconductor",
  蚌埠芯源电子供应链: "Bengbu Xinyuan Electronics Supply Chain",
  宝鸡存储通电子科技: "Baoji Cunchutong Electronics Technology",
  宝鸡科储半导体: "Baoji Kechu Semiconductor",
  宝鸡芯拓电子商贸: "Baoji Xintuo Electronics Trading",
  宝鸡芯源电子供应链: "Baoji Xinyuan Electronics Supply Chain",
  保定存储通电子科技: "Baoding Cunchutong Electronics Technology",
  保定科储半导体: "Baoding Kechu Semiconductor",
  保定芯源电子供应链: "Baoding Xinyuan Electronics Supply Chain",
  北海科储半导体: "Beihai Kechu Semiconductor",
  北海芯拓电子商贸: "Beihai Xintuo Electronics Trading",
  北海芯源电子供应链: "Beihai Xinyuan Electronics Supply Chain",
  北京存储通电子科技: "Beijing Cunchutong Electronics Technology",
  北京华储电子供应链有限公司:
    "Beijing Huachu Electronics Supply Chain Co., Ltd.",
  北京芯拓电子商贸: "Beijing Xintuo Electronics Trading",
  北京芯源电子供应链: "Beijing Xinyuan Electronics Supply Chain",
  沧州存储通电子科技: "Cangzhou Cunchutong Electronics Technology",
  沧州科储半导体: "Cangzhou Kechu Semiconductor",
  沧州芯拓电子商贸: "Cangzhou Xintuo Electronics Trading",
  沧州芯源电子供应链: "Cangzhou Xinyuan Electronics Supply Chain",
  常德科储半导体: "Changde Kechu Semiconductor",
  常德芯拓电子商贸: "Changde Xintuo Electronics Trading",
  常德芯源电子供应链: "Changde Xinyuan Electronics Supply Chain",
  常州存储通电子科技: "Changzhou Cunchutong Electronics Technology",
  常州科储半导体: "Changzhou Kechu Semiconductor",
  常州芯拓电子商贸: "Changzhou Xintuo Electronics Trading",
  成都存储通电子科技: "Chengdu Cunchutong Electronics Technology",
  成都科储半导体: "Chengdu Kechu Semiconductor",
  成都芯源电子供应链: "Chengdu Xinyuan Electronics Supply Chain",
  滁州存储通电子科技: "Chuzhou Cunchutong Electronics Technology",
  滁州芯拓电子商贸: "Chuzhou Xintuo Electronics Trading",
  滁州芯源电子供应链: "Chuzhou Xinyuan Electronics Supply Chain",
  大连存储通电子科技: "Dalian Cunchutong Electronics Technology",
  大连科储半导体: "Dalian Kechu Semiconductor",
  大连芯拓电子商贸: "Dalian Xintuo Electronics Trading",
  丹东存储通电子科技: "Dandong Cunchutong Electronics Technology",
  丹东科储半导体: "Dandong Kechu Semiconductor",
  丹东芯源电子供应链: "Dandong Xinyuan Electronics Supply Chain",
  德阳存储通电子科技: "Deyang Cunchutong Electronics Technology",
  德阳科储半导体: "Deyang Kechu Semiconductor",
  德阳芯拓电子商贸: "Deyang Xintuo Electronics Trading",
  德阳芯源电子供应链: "Deyang Xinyuan Electronics Supply Chain",
  东莞存储通电子科技: "Dongguan Cunchutong Electronics Technology",
  东莞芯拓电子商贸: "Dongguan Xintuo Electronics Trading",
  东莞芯源电子供应链: "Dongguan Xinyuan Electronics Supply Chain",
  佛山科储半导体: "Foshan Kechu Semiconductor",
  佛山芯拓电子商贸: "Foshan Xintuo Electronics Trading",
  佛山芯源电子供应链: "Foshan Xinyuan Electronics Supply Chain",
  福州存储通电子科技: "Fuzhou Cunchutong Electronics Technology",
  福州科储半导体: "Fuzhou Kechu Semiconductor",
  福州芯源电子供应链: "Fuzhou Xinyuan Electronics Supply Chain",
  赣州科储半导体: "Ganzhou Kechu Semiconductor",
  赣州芯拓电子商贸: "Ganzhou Xintuo Electronics Trading",
  赣州芯源电子供应链: "Ganzhou Xinyuan Electronics Supply Chain",
  广州存储通电子科技: "Guangzhou Cunchutong Electronics Technology",
  广州科储半导体: "Guangzhou Kechu Semiconductor",
  广州悦沈电子科技: "Guangzhou Yueshen Electronics Technology",
  桂林存储通电子科技: "Guilin Cunchutong Electronics Technology",
  桂林芯拓电子商贸: "Guilin Xintuo Electronics Trading",
  桂林芯源电子供应链: "Guilin Xinyuan Electronics Supply Chain",
  邯郸科储半导体: "Handan Kechu Semiconductor",
  邯郸芯拓电子商贸: "Handan Xintuo Electronics Trading",
  邯郸芯源电子供应链: "Handan Xinyuan Electronics Supply Chain",
  汉中存储通电子科技: "Hanzhong Cunchutong Electronics Technology",
  汉中芯拓电子商贸: "Hanzhong Xintuo Electronics Trading",
  汉中芯源电子供应链: "Hanzhong Xinyuan Electronics Supply Chain",
  杭州存储通电子科技: "Hangzhou Cunchutong Electronics Technology",
  杭州科储半导体: "Hangzhou Kechu Semiconductor",
  杭州芯源电子供应链: "Hangzhou Xinyuan Electronics Supply Chain",
  合肥存储通电子科技: "Hefei Cunchutong Electronics Technology",
  合肥科储半导体: "Hefei Kechu Semiconductor",
  合肥芯拓电子商贸: "Hefei Xintuo Electronics Trading",
  合肥芯源电子供应链: "Hefei Xinyuan Electronics Supply Chain",
  衡阳存储通电子科技: "Hengyang Cunchutong Electronics Technology",
  衡阳芯拓电子商贸: "Hengyang Xintuo Electronics Trading",
  衡阳芯源电子供应链: "Hengyang Xinyuan Electronics Supply Chain",
  华秋商城: "Huaqiu Mall",
  黄石科储半导体: "Huangshi Kechu Semiconductor",
  黄石芯拓电子商贸: "Huangshi Xintuo Electronics Trading",
  黄石芯源电子供应链: "Huangshi Xinyuan Electronics Supply Chain",
  惠州存储通电子科技: "Huizhou Cunchutong Electronics Technology",
  惠州科储半导体: "Huizhou Kechu Semiconductor",
  惠州芯拓电子商贸: "Huizhou Xintuo Electronics Trading",
  惠州芯源电子供应链: "Huizhou Xinyuan Electronics Supply Chain",
  吉安科储半导体: "Ji'an Kechu Semiconductor",
  吉安芯拓电子商贸: "Ji'an Xintuo Electronics Trading",
  吉安芯源电子供应链: "Ji'an Xinyuan Electronics Supply Chain",
  济南存储通电子科技: "Jinan Cunchutong Electronics Technology",
  济南芯拓电子商贸: "Jinan Xintuo Electronics Trading",
  济南芯源电子供应链: "Jinan Xinyuan Electronics Supply Chain",
  嘉兴存储通电子科技: "Jiaxing Cunchutong Electronics Technology",
  嘉兴科储半导体: "Jiaxing Kechu Semiconductor",
  嘉兴芯拓电子商贸: "Jiaxing Xintuo Electronics Trading",
  嘉兴芯源电子供应链: "Jiaxing Xinyuan Electronics Supply Chain",
  金华存储通电子科技: "Jinhua Cunchutong Electronics Technology",
  金华科储半导体: "Jinhua Kechu Semiconductor",
  金华芯拓电子商贸: "Jinhua Xintuo Electronics Trading",
  锦州存储通电子科技: "Jinzhou Cunchutong Electronics Technology",
  锦州科储半导体: "Jinzhou Kechu Semiconductor",
  锦州芯拓电子商贸: "Jinzhou Xintuo Electronics Trading",
  荆州存储通电子科技: "Jingzhou Cunchutong Electronics Technology",
  荆州科储半导体: "Jingzhou Kechu Semiconductor",
  荆州芯拓电子商贸: "Jingzhou Xintuo Electronics Trading",
  荆州芯源电子供应链: "Jingzhou Xinyuan Electronics Supply Chain",
  九江存储通电子科技: "Jiujiang Cunchutong Electronics Technology",
  九江科储半导体: "Jiujiang Kechu Semiconductor",
  九江芯拓电子商贸: "Jiujiang Xintuo Electronics Trading",
  九江芯源电子供应链: "Jiujiang Xinyuan Electronics Supply Chain",
  廊坊存储通电子科技: "Langfang Cunchutong Electronics Technology",
  廊坊科储半导体: "Langfang Kechu Semiconductor",
  廊坊芯拓电子商贸: "Langfang Xintuo Electronics Trading",
  乐山存储通电子科技: "Leshan Cunchutong Electronics Technology",
  乐山科储半导体: "Leshan Kechu Semiconductor",
  乐山芯源电子供应链: "Leshan Xinyuan Electronics Supply Chain",
  立创商城: "Lichuang Mall",
  柳州存储通电子科技: "Liuzhou Cunchutong Electronics Technology",
  柳州科储半导体: "Liuzhou Kechu Semiconductor",
  柳州芯拓电子商贸: "Liuzhou Xintuo Electronics Trading",
  柳州芯源电子供应链: "Liuzhou Xinyuan Electronics Supply Chain",
  龙岩存储通电子科技: "Longyan Cunchutong Electronics Technology",
  龙岩科储半导体: "Longyan Kechu Semiconductor",
  龙岩芯拓电子商贸: "Longyan Xintuo Electronics Trading",
  洛阳存储通电子科技: "Luoyang Cunchutong Electronics Technology",
  洛阳科储半导体: "Luoyang Kechu Semiconductor",
  洛阳芯拓电子商贸: "Luoyang Xintuo Electronics Trading",
  马鞍山存储通电子科技: "Ma'anshan Cunchutong Electronics Technology",
  马鞍山科储半导体: "Ma'anshan Kechu Semiconductor",
  马鞍山芯拓电子商贸: "Ma'anshan Xintuo Electronics Trading",
  绵阳存储通电子科技: "Mianyang Cunchutong Electronics Technology",
  绵阳科储半导体: "Mianyang Kechu Semiconductor",
  绵阳芯拓电子商贸: "Mianyang Xintuo Electronics Trading",
  南昌存储通电子科技: "Nanchang Cunchutong Electronics Technology",
  南昌芯拓电子商贸: "Nanchang Xintuo Electronics Trading",
  南昌芯源电子供应链: "Nanchang Xinyuan Electronics Supply Chain",
  南充存储通电子科技: "Nanchong Cunchutong Electronics Technology",
  南充科储半导体: "Nanchong Kechu Semiconductor",
  南充芯拓电子商贸: "Nanchong Xintuo Electronics Trading",
  南京存储通电子科技: "Nanjing Cunchutong Electronics Technology",
  南京芯拓电子商贸: "Nanjing Xintuo Electronics Trading",
  南京芯源电子供应链: "Nanjing Xinyuan Electronics Supply Chain",
  南宁存储通电子科技: "Nanning Cunchutong Electronics Technology",
  南宁科储半导体: "Nanning Kechu Semiconductor",
  南宁芯源电子供应链: "Nanning Xinyuan Electronics Supply Chain",
  南通存储通电子科技: "Nantong Cunchutong Electronics Technology",
  南通科储半导体: "Nantong Kechu Semiconductor",
  南通芯拓电子商贸: "Nantong Xintuo Electronics Trading",
  南通芯源电子供应链: "Nantong Xinyuan Electronics Supply Chain",
  南阳存储通电子科技: "Nanyang Cunchutong Electronics Technology",
  南阳科储半导体: "Nanyang Kechu Semiconductor",
  南阳芯源电子供应链: "Nanyang Xinyuan Electronics Supply Chain",
  宁波存储通电子科技: "Ningbo Cunchutong Electronics Technology",
  宁波科储半导体: "Ningbo Kechu Semiconductor",
  宁波芯拓电子商贸: "Ningbo Xintuo Electronics Trading",
  莆田存储通电子科技: "Putian Cunchutong Electronics Technology",
  莆田科储半导体: "Putian Kechu Semiconductor",
  莆田芯源电子供应链: "Putian Xinyuan Electronics Supply Chain",
  青岛科储半导体: "Qingdao Kechu Semiconductor",
  青岛芯拓电子商贸: "Qingdao Xintuo Electronics Trading",
  青岛芯源电子供应链: "Qingdao Xinyuan Electronics Supply Chain",
  泉州存储通电子科技: "Quanzhou Cunchutong Electronics Technology",
  泉州芯拓电子商贸: "Quanzhou Xintuo Electronics Trading",
  泉州芯源电子供应链: "Quanzhou Xinyuan Electronics Supply Chain",
  厦门存储通电子科技: "Xiamen Cunchutong Electronics Technology",
  厦门科储半导体: "Xiamen Kechu Semiconductor",
  厦门芯拓电子商贸: "Xiamen Xintuo Electronics Trading",
  厦门芯源电子供应链: "Xiamen Xinyuan Electronics Supply Chain",
  上海科储半导体: "Shanghai Kechu Semiconductor",
  上海芯拓电子商贸: "Shanghai Xintuo Electronics Trading",
  上海芯途电子科技有限公司: "Shanghai Xintu Electronics Technology Co., Ltd.",
  上海芯源电子供应链: "Shanghai Xinyuan Electronics Supply Chain",
  上饶存储通电子科技: "Shangrao Cunchutong Electronics Technology",
  上饶科储半导体: "Shangrao Kechu Semiconductor",
  上饶芯拓电子商贸: "Shangrao Xintuo Electronics Trading",
  绍兴存储通电子科技: "Shaoxing Cunchutong Electronics Technology",
  绍兴科储半导体: "Shaoxing Kechu Semiconductor",
  绍兴芯源电子供应链: "Shaoxing Xinyuan Electronics Supply Chain",
  深圳存储通电子科技: "Shenzhen Cunchutong Electronics Technology",
  深圳科储半导体: "Shenzhen Kechu Semiconductor",
  深圳芯源电子供应链: "Shenzhen Xinyuan Electronics Supply Chain",
  沈阳存储通电子科技: "Shenyang Cunchutong Electronics Technology",
  沈阳科储半导体: "Shenyang Kechu Semiconductor",
  沈阳芯源电子供应链: "Shenyang Xinyuan Electronics Supply Chain",
  石家庄存储通电子科技: "Shijiazhuang Cunchutong Electronics Technology",
  石家庄芯拓电子商贸: "Shijiazhuang Xintuo Electronics Trading",
  石家庄芯源电子供应链: "Shijiazhuang Xinyuan Electronics Supply Chain",
  世强硬创: "Shiqiang Innovation",
  苏州科储半导体: "Suzhou Kechu Semiconductor",
  苏州芯拓电子商贸: "Suzhou Xintuo Electronics Trading",
  苏州芯源电子供应链: "Suzhou Xinyuan Electronics Supply Chain",
  唐山科储半导体: "Tangshan Kechu Semiconductor",
  唐山芯拓电子商贸: "Tangshan Xintuo Electronics Trading",
  唐山芯源电子供应链: "Tangshan Xinyuan Electronics Supply Chain",
  威海科储半导体: "Weihai Kechu Semiconductor",
  威海芯拓电子商贸: "Weihai Xintuo Electronics Trading",
  威海芯源电子供应链: "Weihai Xinyuan Electronics Supply Chain",
  潍坊存储通电子科技: "Weifang Cunchutong Electronics Technology",
  潍坊科储半导体: "Weifang Kechu Semiconductor",
  潍坊芯拓电子商贸: "Weifang Xintuo Electronics Trading",
  渭南存储通电子科技: "Weinan Cunchutong Electronics Technology",
  渭南科储半导体: "Weinan Kechu Semiconductor",
  渭南芯拓电子商贸: "Weinan Xintuo Electronics Trading",
  温州存储通电子科技: "Wenzhou Cunchutong Electronics Technology",
  温州芯拓电子商贸: "Wenzhou Xintuo Electronics Trading",
  温州芯源电子供应链: "Wenzhou Xinyuan Electronics Supply Chain",
  无锡存储通电子科技: "Wuxi Cunchutong Electronics Technology",
  无锡科储半导体: "Wuxi Kechu Semiconductor",
  无锡芯源电子供应链: "Wuxi Xinyuan Electronics Supply Chain",
  芜湖科储半导体: "Wuhu Kechu Semiconductor",
  芜湖芯拓电子商贸: "Wuhu Xintuo Electronics Trading",
  芜湖芯源电子供应链: "Wuhu Xinyuan Electronics Supply Chain",
  梧州存储通电子科技: "Wuzhou Cunchutong Electronics Technology",
  梧州科储半导体: "Wuzhou Kechu Semiconductor",
  梧州芯拓电子商贸: "Wuzhou Xintuo Electronics Trading",
  武汉存储通电子科技: "Wuhan Cunchutong Electronics Technology",
  武汉科储半导体: "Wuhan Kechu Semiconductor",
  武汉芯源电子供应链: "Wuhan Xinyuan Electronics Supply Chain",
  西安存储通电子科技: "Xi'an Cunchutong Electronics Technology",
  西安芯拓电子商贸: "Xi'an Xintuo Electronics Trading",
  西安芯源电子供应链: "Xi'an Xinyuan Electronics Supply Chain",
  咸阳存储通电子科技: "Xianyang Cunchutong Electronics Technology",
  咸阳科储半导体: "Xianyang Kechu Semiconductor",
  咸阳芯源电子供应链: "Xianyang Xinyuan Electronics Supply Chain",
  湘潭存储通电子科技: "Xiangtan Cunchutong Electronics Technology",
  湘潭科储半导体: "Xiangtan Kechu Semiconductor",
  湘潭芯源电子供应链: "Xiangtan Xinyuan Electronics Supply Chain",
  襄阳存储通电子科技: "Xiangyang Cunchutong Electronics Technology",
  襄阳芯拓电子商贸: "Xiangyang Xintuo Electronics Trading",
  襄阳芯源电子供应链: "Xiangyang Xinyuan Electronics Supply Chain",
  孝感存储通电子科技: "Xiaogan Cunchutong Electronics Technology",
  孝感科储半导体: "Xiaogan Kechu Semiconductor",
  孝感芯拓电子商贸: "Xiaogan Xintuo Electronics Trading",
  新乡存储通电子科技: "Xinxiang Cunchutong Electronics Technology",
  新乡芯拓电子商贸: "Xinxiang Xintuo Electronics Trading",
  新乡芯源电子供应链: "Xinxiang Xinyuan Electronics Supply Chain",
  许昌科储半导体: "Xuchang Kechu Semiconductor",
  许昌芯拓电子商贸: "Xuchang Xintuo Electronics Trading",
  许昌芯源电子供应链: "Xuchang Xinyuan Electronics Supply Chain",
  烟台存储通电子科技: "Yantai Cunchutong Electronics Technology",
  烟台科储半导体: "Yantai Kechu Semiconductor",
  烟台芯拓电子商贸: "Yantai Xintuo Electronics Trading",
  烟台芯源电子供应链: "Yantai Xinyuan Electronics Supply Chain",
  扬州科储半导体: "Yangzhou Kechu Semiconductor",
  扬州芯拓电子商贸: "Yangzhou Xintuo Electronics Trading",
  扬州芯源电子供应链: "Yangzhou Xinyuan Electronics Supply Chain",
  宜宾科储半导体: "Yibin Kechu Semiconductor",
  宜宾芯拓电子商贸: "Yibin Xintuo Electronics Trading",
  宜宾芯源电子供应链: "Yibin Xinyuan Electronics Supply Chain",
  宜昌存储通电子科技: "Yichang Cunchutong Electronics Technology",
  宜昌科储半导体: "Yichang Kechu Semiconductor",
  宜昌芯拓电子商贸: "Yichang Xintuo Electronics Trading",
  宜春存储通电子科技: "Yichun Cunchutong Electronics Technology",
  宜春芯拓电子商贸: "Yichun Xintuo Electronics Trading",
  宜春芯源电子供应链: "Yichun Xinyuan Electronics Supply Chain",
  营口存储通电子科技: "Yingkou Cunchutong Electronics Technology",
  营口科储半导体: "Yingkou Kechu Semiconductor",
  营口芯拓电子商贸: "Yingkou Xintuo Electronics Trading",
  营口芯源电子供应链: "Yingkou Xinyuan Electronics Supply Chain",
  榆林科储半导体: "Yulin Kechu Semiconductor",
  榆林芯拓电子商贸: "Yulin Xintuo Electronics Trading",
  榆林芯源电子供应链: "Yulin Xinyuan Electronics Supply Chain",
  玉林存储通电子科技: "Yulin Cunchutong Electronics Technology",
  玉林科储半导体: "Yulin Kechu Semiconductor",
  玉林芯源电子供应链: "Yulin Xinyuan Electronics Supply Chain",
  岳阳存储通电子科技: "Yueyang Cunchutong Electronics Technology",
  岳阳科储半导体: "Yueyang Kechu Semiconductor",
  岳阳芯拓电子商贸: "Yueyang Xintuo Electronics Trading",
  岳阳芯源电子供应链: "Yueyang Xinyuan Electronics Supply Chain",
  云汉芯城: "Yunhan Chip Mall",
  漳州科储半导体: "Zhangzhou Kechu Semiconductor",
  漳州芯拓电子商贸: "Zhangzhou Xintuo Electronics Trading",
  漳州芯源电子供应链: "Zhangzhou Xinyuan Electronics Supply Chain",
  长沙存储通电子科技: "Changsha Cunchutong Electronics Technology",
  长沙芯拓电子商贸: "Changsha Xintuo Electronics Trading",
  长沙芯源电子供应链: "Changsha Xinyuan Electronics Supply Chain",
  郑州存储通电子科技: "Zhengzhou Cunchutong Electronics Technology",
  郑州科储半导体: "Zhengzhou Kechu Semiconductor",
  郑州芯拓电子商贸: "Zhengzhou Xintuo Electronics Trading",
  郑州芯源电子供应链: "Zhengzhou Xinyuan Electronics Supply Chain",
  株洲科储半导体: "Zhuzhou Kechu Semiconductor",
  株洲芯拓电子商贸: "Zhuzhou Xintuo Electronics Trading",
  株洲芯源电子供应链: "Zhuzhou Xinyuan Electronics Supply Chain",
  珠海存储通电子科技: "Zhuhai Cunchutong Electronics Technology",
  珠海科储半导体: "Zhuhai Kechu Semiconductor",
  珠海芯源电子供应链: "Zhuhai Xinyuan Electronics Supply Chain",
  淄博存储通电子科技: "Zibo Cunchutong Electronics Technology",
  淄博芯拓电子商贸: "Zibo Xintuo Electronics Trading",
  淄博芯源电子供应链: "Zibo Xinyuan Electronics Supply Chain",
  XSOU专属报价: "XSOU Exclusive Quotes",
});

// 已登记产品显示名；不修改料号、产品身份与风险等级
export const productNames = Object.freeze({
  "ADATA USB闪存盘 128GB": "ADATA USB flash drive 128GB",
  "CXMT DDR4 16Gb x8 晶圆Demo": "CXMT DDR4 16Gb x8 Wafer Demo",
  "CXMT DDR4 8Gb x8 晶圆Demo": "CXMT DDR4 8Gb x8 Wafer Demo",
  "CXMT DDR5 16Gb x8 晶圆Demo": "CXMT DDR5 16Gb x8 Wafer Demo",
  "Intel 144L QLC 1Tb 晶圆Demo": "Intel 144L QLC 1Tb Wafer Demo",
  "KIOXIA BiCS5 TLC 512Gb 晶圆Demo": "KIOXIA BiCS5 TLC 512Gb Wafer Demo",
  "KIOXIA BiCS6 TLC 1Tb 晶圆Demo": "KIOXIA BiCS6 TLC 1Tb Wafer Demo",
  "KIOXIA USB闪存盘 128GB": "KIOXIA USB flash drive 128GB",
  "KIOXIA 企业级 SSD 2TB": "KIOXIA Enterprise SSD 2TB",
  "Kingston USB闪存盘 128GB": "Kingston USB flash drive 128GB",
  "Lexar USB闪存盘 128GB": "Lexar USB flash drive 128GB",
  "Macronix MX30 MLC 8Gb 晶圆Demo": "Macronix MX30 MLC 8Gb Wafer Demo",
  "Micron B47R TLC 512Gb 晶圆Demo": "Micron B47R TLC 512Gb Wafer Demo",
  "Micron B58R TLC 1Tb 晶圆Demo": "Micron B58R TLC 1Tb Wafer Demo",
  "Micron DDR5 16Gb x8 晶圆Demo": "Micron DDR5 16Gb x8 Wafer Demo",
  "Micron DDR5 32Gb x8 晶圆Demo": "Micron DDR5 32Gb x8 Wafer Demo",
  "Micron HBM2E 8Gb x4 晶圆Demo": "Micron HBM2E 8Gb x4 Wafer Demo",
  "Micron LPDDR5 16Gb x16 晶圆Demo": "Micron LPDDR5 16Gb x16 Wafer Demo",
  "Micron 企业级 SSD 2TB": "Micron Enterprise SSD 2TB",
  "Nanya DDR4 8Gb x8 晶圆Demo": "Nanya DDR4 8Gb x8 Wafer Demo",
  "Nanya DDR5 16Gb x8 晶圆Demo": "Nanya DDR5 16Gb x8 Wafer Demo",
  "Netac USB闪存盘 128GB": "Netac USB flash drive 128GB",
  "PNY USB闪存盘 128GB": "PNY USB flash drive 128GB",
  "SK hynix DDR5 16Gb x8 晶圆Demo": "SK hynix DDR5 16Gb x8 Wafer Demo",
  "SK hynix DDR5 24Gb x8 晶圆Demo": "SK hynix DDR5 24Gb x8 Wafer Demo",
  "SK hynix HBM3 16Gb x4 晶圆Demo": "SK hynix HBM3 16Gb x4 Wafer Demo",
  "SK hynix V7 TLC 512Gb 晶圆Demo": "SK hynix V7 TLC 512Gb Wafer Demo",
  "SK hynix V8 QLC 1Tb 晶圆Demo": "SK hynix V8 QLC 1Tb Wafer Demo",
  "Samsung DDR5 16Gb x8 晶圆Demo": "Samsung DDR5 16Gb x8 Wafer Demo",
  "Samsung DDR5 24Gb x8 晶圆Demo": "Samsung DDR5 24Gb x8 Wafer Demo",
  "Samsung HBM3E 24Gb x4 晶圆Demo": "Samsung HBM3E 24Gb x4 Wafer Demo",
  "Samsung LPDDR5 16Gb x16 晶圆Demo": "Samsung LPDDR5 16Gb x16 Wafer Demo",
  "Samsung USB闪存盘 128GB": "Samsung USB flash drive 128GB",
  "Samsung V6 TLC 512Gb 晶圆Demo": "Samsung V6 TLC 512Gb Wafer Demo",
  "Samsung V7 TLC 512Gb 晶圆Demo": "Samsung V7 TLC 512Gb Wafer Demo",
  "Samsung V8 TLC 1Tb 晶圆Demo": "Samsung V8 TLC 1Tb Wafer Demo",
  "Samsung 企业级 SSD 2TB": "Samsung Enterprise SSD 2TB",
  "SanDisk BiCS5 TLC 512Gb 晶圆Demo": "SanDisk BiCS5 TLC 512Gb Wafer Demo",
  "SanDisk USB闪存盘 128GB": "SanDisk USB flash drive 128GB",
  "Seagate 企业级 SSD 2TB": "Seagate Enterprise SSD 2TB",
  "SpecTek DDR4 8Gb x8 重构晶圆Demo":
    "SpecTek DDR4 8Gb x8 Reconstructed Wafer Demo",
  "SpecTek E0 TLC 256Gb 重构晶圆Demo":
    "SpecTek E0 TLC 256Gb Reconstructed Wafer Demo",
  "Teclast USB闪存盘 128GB": "Teclast USB flash drive 128GB",
  "Transcend USB闪存盘 128GB": "Transcend USB flash drive 128GB",
  "Winbond DDR3 4Gb x16 晶圆Demo": "Winbond DDR3 4Gb x16 Wafer Demo",
  "Winbond DDR4 8Gb x16 晶圆Demo": "Winbond DDR4 8Gb x16 Wafer Demo",
  "Winbond W25N SLC 4Gb 晶圆Demo": "Winbond W25N SLC 4Gb Wafer Demo",
  "Winbond W25Q NOR 2Gb 晶圆Demo": "Winbond W25Q NOR 2Gb Wafer Demo",
  "YMTC X1-9050 TLC 256Gb 晶圆Demo": "YMTC X1-9050 TLC 256Gb Wafer Demo",
  "YMTC X2-9060 TLC 512Gb 晶圆Demo": "YMTC X2-9060 TLC 512Gb Wafer Demo",
  "YMTC X3-9060 TLC 512Gb 晶圆Demo": "YMTC X3-9060 TLC 512Gb Wafer Demo",
  "YMTC X3-9070 TLC 1Tb 晶圆Demo": "YMTC X3-9070 TLC 1Tb Wafer Demo",
  "白片 TLC 512Gb": "White-chip TLC 512Gb",
  "白片口径 DDR4 8Gb (1Gx8)": "White-chip specification DDR4 8Gb (1Gx8)",
  "白片口径 DDR4 UDIMM 16GB": "White-chip specification DDR4 UDIMM 16GB",
  "白片颗粒方案 MicroSD 128GB": "White-chip component scheme MicroSD 128GB",
  "白片颗粒方案 SATA SSD 512GB": "White-chip component scheme SATA SSD 512GB",
  "白片颗粒方案 USB闪存盘 128GB":
    "White-chip component scheme USB flash drive 128GB",
  "白片颗粒方案 eMMC 64GB": "White-chip component scheme eMMC 64GB",
  "黑片/回收颗粒风险 SATA SSD 512GB":
    "Black-chip/reclaimed-component risk SATA SSD 512GB",
  "黑片/回收颗粒风险 eMMC 64GB":
    "Black-chip/reclaimed-component risk eMMC 64GB",
  "黑片/打磨颗粒风险 DDR4 UDIMM 16GB":
    "Black-chip/resurfaced-component risk DDR4 UDIMM 16GB",
  "黑片/扩容风险 MicroSD 128GB":
    "Black-chip/capacity-inflation risk MicroSD 128GB",
  "黑片/扩容风险 USB闪存盘 128GB":
    "Black-chip/capacity-inflation risk USB flash drive 128GB",
  "黑片风险 DDR4 8Gb (1Gx8)": "Black-chip risk DDR4 8Gb (1Gx8)",
  "黑片高风险 TLC 512Gb": "High-risk black-chip TLC 512Gb",
});

// 系统地理目录显示名；不转换公司名、自由地址或数据库原文
export const regionNames = Object.freeze({
  中国: "China",
  北京: "Beijing",
  上海: "Shanghai",
  香港: "Hong Kong",
  澳门: "Macao",
  广东: "Guangdong",
  深圳: "Shenzhen",
  广州: "Guangzhou",
  东莞: "Dongguan",
  佛山: "Foshan",
  珠海: "Zhuhai",
  惠州: "Huizhou",
  江苏: "Jiangsu",
  南京: "Nanjing",
  苏州: "Suzhou",
  无锡: "Wuxi",
  常州: "Changzhou",
  南通: "Nantong",
  扬州: "Yangzhou",
  浙江: "Zhejiang",
  杭州: "Hangzhou",
  宁波: "Ningbo",
  温州: "Wenzhou",
  嘉兴: "Jiaxing",
  绍兴: "Shaoxing",
  金华: "Jinhua",
  山东: "Shandong",
  济南: "Jinan",
  青岛: "Qingdao",
  烟台: "Yantai",
  潍坊: "Weifang",
  淄博: "Zibo",
  威海: "Weihai",
  福建: "Fujian",
  福州: "Fuzhou",
  厦门: "Xiamen",
  泉州: "Quanzhou",
  漳州: "Zhangzhou",
  莆田: "Putian",
  龙岩: "Longyan",
  安徽: "Anhui",
  合肥: "Hefei",
  芜湖: "Wuhu",
  蚌埠: "Bengbu",
  马鞍山: "Ma'anshan",
  滁州: "Chuzhou",
  安庆: "Anqing",
  湖北: "Hubei",
  武汉: "Wuhan",
  宜昌: "Yichang",
  襄阳: "Xiangyang",
  黄石: "Huangshi",
  荆州: "Jingzhou",
  孝感: "Xiaogan",
  湖南: "Hunan",
  长沙: "Changsha",
  株洲: "Zhuzhou",
  湘潭: "Xiangtan",
  岳阳: "Yueyang",
  衡阳: "Hengyang",
  常德: "Changde",
  四川: "Sichuan",
  成都: "Chengdu",
  绵阳: "Mianyang",
  德阳: "Deyang",
  宜宾: "Yibin",
  乐山: "Leshan",
  南充: "Nanchong",
  陕西: "Shaanxi",
  西安: "Xi'an",
  宝鸡: "Baoji",
  咸阳: "Xianyang",
  渭南: "Weinan",
  汉中: "Hanzhong",
  榆林: "Yulin",
  河南: "Henan",
  郑州: "Zhengzhou",
  洛阳: "Luoyang",
  新乡: "Xinxiang",
  许昌: "Xuchang",
  南阳: "Nanyang",
  安阳: "Anyang",
  河北: "Hebei",
  石家庄: "Shijiazhuang",
  唐山: "Tangshan",
  保定: "Baoding",
  廊坊: "Langfang",
  沧州: "Cangzhou",
  邯郸: "Handan",
  辽宁: "Liaoning",
  沈阳: "Shenyang",
  大连: "Dalian",
  鞍山: "Anshan",
  营口: "Yingkou",
  丹东: "Dandong",
  锦州: "Jinzhou",
  江西: "Jiangxi",
  南昌: "Nanchang",
  赣州: "Ganzhou",
  九江: "Jiujiang",
  上饶: "Shangrao",
  宜春: "Yichun",
  吉安: "Ji'an",
  广西: "Guangxi",
  南宁: "Nanning",
  柳州: "Liuzhou",
  桂林: "Guilin",
  北海: "Beihai",
  玉林: "Yulin",
  梧州: "Wuzhou",
  美国: "United States",
  加利福尼亚州: "California",
  洛杉矶: "Los Angeles",
  旧金山: "San Francisco",
  圣何塞: "San Jose",
  得克萨斯州: "Texas",
  奥斯汀: "Austin",
  达拉斯: "Dallas",
  休斯敦: "Houston",
  纽约州: "New York State",
  纽约: "New York",
  布法罗: "Buffalo",
  奥尔巴尼: "Albany",
  日本: "Japan",
  东京都: "Tokyo Metropolis",
  八王子: "Hachioji",
  町田: "Machida",
  立川: "Tachikawa",
  大阪府: "Osaka Prefecture",
  大阪: "Osaka",
  堺: "Sakai",
  吹田: "Suita",
  爱知县: "Aichi Prefecture",
  名古屋: "Nagoya",
  丰田: "Toyota",
  冈崎: "Okazaki",
  新加坡: "Singapore",
  中区: "Central Region",
  碧山: "Bishan",
  女皇镇: "Queenstown",
  大巴窑: "Toa Payoh",
  东区: "East Region",
  淡滨尼: "Tampines",
  勿洛: "Bedok",
  巴西立: "Pasir Ris",
  西区: "West Region",
  裕廊东: "Jurong East",
  裕廊西: "Jurong West",
  金文泰: "Clementi",
  "归属未知（演示）": "Unknown region (demo)",
});
